(function() {
  'use strict';

  const data = window.ShoogieGolfComponentBuilderData;
  if (!data || !Array.isArray(data.shells) || !Array.isArray(data.inserts) || !Array.isArray(data.laces)) return;

  let builderInstanceSeq = 0;
  let bagbPopCloseHandlers = null;

  const collectionLabels = {
    all: 'All shoes',
    whiteOne: 'White 1 Color',
    whiteTwo: 'White 2 Color',
    black: 'Black',
    camo: 'Camo',
    collabs: 'Collabs',
    glow: 'Glow in the Dark',
    novelty: 'Sandals & Feet'
  };

  const collectionOrder = ['all', 'whiteOne', 'whiteTwo', 'black', 'camo', 'collabs', 'glow', 'novelty'];

  const swatchColors = {
    black: '#111111',
    blue: '#2468c9',
    brown: '#7b4d2a',
    bronze: '#b57a3f',
    green: '#168457',
    gray: '#767676',
    grey: '#767676',
    navy: '#0a1857',
    orange: '#f47a2a',
    pink: '#f5a3c7',
    purple: '#7a43b6',
    red: '#d83b35',
    silver: '#c9c9c9',
    teal: '#25b9ba',
    white: '#f7f7f2',
    yellow: '#f2d63d',
    neon: '#d7ff01',
    glow: '#d7ff01'
  };

  const bagColors = [
    { id: 'black', label: 'Black', color: '#111111', laceTokens: ['white', 'black'] },
    { id: 'white', label: 'White', color: '#f7f7f2', laceTokens: ['white', 'black'] },
    { id: 'gray', label: 'Gray', color: '#767676', laceTokens: ['white', 'black'] },
    { id: 'brown', label: 'Tan / Brown', color: '#7b4d2a', laceTokens: ['brown', 'white'] },
    { id: 'navy', label: 'Navy', color: '#0a1857', laceTokens: ['white', 'blue'] },
    { id: 'blue', label: 'Blue', color: '#2468c9', laceTokens: ['white', 'blue'] },
    { id: 'teal', label: 'Teal', color: '#25b9ba', laceTokens: ['teal', 'white'] },
    { id: 'green', label: 'Green', color: '#168457', laceTokens: ['white', 'green'] },
    { id: 'yellow', label: 'Yellow', color: '#f2d63d', laceTokens: ['yellow', 'white'] },
    { id: 'orange', label: 'Orange', color: '#f47a2a', laceTokens: ['orange', 'white'] },
    { id: 'red', label: 'Red', color: '#d83b35', laceTokens: ['red', 'white'] },
    { id: 'pink', label: 'Pink', color: '#f5a3c7', laceTokens: ['pink', 'white'] },
    { id: 'purple', label: 'Purple', color: '#7a43b6', laceTokens: ['purple', 'white'] }
  ];

  // Colors a shoe can be, and which bag colors count as "near" a shoe color
  // (a blue shoe is a reasonable echo of a navy or teal bag).
  const shellColorNames = ['black', 'white', 'gray', 'navy', 'blue', 'teal', 'green', 'yellow', 'orange', 'red', 'pink', 'purple', 'brown', 'silver', 'bronze'];
  const nearColors = {
    navy: ['blue'],
    blue: ['navy', 'teal'],
    teal: ['blue'],
    gray: ['silver'],
    brown: ['bronze']
  };

  const standSizes = [
    { id: 'standard', title: 'Standard', insert: 'standard', hint: '11–13 mm legs' },
    { id: 'small', title: 'Small', insert: 'small', hint: '9–10 mm legs' }
  ];

  function money(cents) {
    if (window.ShoogieGolf?.formatMoney) return window.ShoogieGolf.formatMoney(cents || 0);
    return '$' + ((cents || 0) / 100).toFixed(2);
  }

  function escapeHtml(value) {
    const div = document.createElement('div');
    div.textContent = value == null ? '' : String(value);
    return div.innerHTML;
  }

  function normalizeHandle(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/^\/products\//, '')
      .replace(/[^a-z0-9-]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function tokenText(value) {
    return normalizeHandle(value).replace(/-/g, ' ');
  }

  function colorFor(value) {
    const text = normalizeHandle(value);
    const parts = text.split('-');
    const first = parts.find(part => swatchColors[part]);
    return swatchColors[first] || '#d7ff01';
  }

  function createKitId(prefix) {
    return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
  }

  function plural(value, singular, pluralized) {
    return `${value} ${value === 1 ? singular : pluralized}`;
  }

  function shellCollection(shell) {
    if (shell.kind === 'sandal' || shell.kind === 'sasquatch') return 'novelty';
    const text = [
      shell.title,
      shell.fullTitle,
      shell.handle,
      shell.colorHandle,
      shell.sku,
      ...(Array.isArray(shell.sourceHandles) ? shell.sourceHandles : [])
    ].join(' ').toLowerCase();

    if (text.includes('glow')) return 'glow';
    if (text.includes('camo')) return 'camo';
    if (text.includes('bryan') || text.includes('collab')) return 'collabs';
    if (shell.family === 'three-color') return 'whiteTwo';
    if (shell.family === 'premium') return 'black';
    return 'whiteOne';
  }

  function shellKindLabel(shell) {
    if (shell.kind === 'sandal') return 'Sandal pair';
    if (shell.kind === 'sasquatch') return 'Feet pair';
    return 'Shoe pair';
  }

  function shellByVariant(id) {
    return data.shells.find(shell => shell.variantId === id);
  }

  function insertByVariant(id) {
    return data.inserts.find(insert => insert.variantId === id);
  }

  function laceByVariant(id) {
    return data.laces.find(lace => lace.variantId === id);
  }

  function usableShells() {
    return data.shells.filter(shell => shell.active);
  }

  function usableInserts() {
    return data.inserts.filter(insert => insert.active && insert.available);
  }

  function usableLaces() {
    return data.laces.filter(lace => lace.active && lace.available);
  }

  function bagColor(id) {
    return bagColors.find(color => color.id === id) || null;
  }

  function standSize(id) {
    return standSizes.find(size => size.id === id) || null;
  }

  function shellColorList(shell) {
    // Source of truth: explicit color-* product tags, delivered by the data
    // generator as shell.colors. Title parsing is only a fallback for
    // products that haven't been tagged yet.
    if (Array.isArray(shell.colors) && shell.colors.length) return shell.colors;
    const text = tokenText([shell.colorHandle, shell.title].join(' ')).replace(/grey/g, 'gray');
    return shellColorNames.filter(name => text.includes(name));
  }

  /* ---------- Dynamic recolored shoe (3/4 view, traced from the real product).
     Six regions recolored from the shell colorway rule + chosen lace, so ONE
     asset covers every shoe variant. Color rule + region schema documented in
     project memory "build-by-bag-shoe-preview". ---------- */
  function classifyShell(shell) {
    const t = (shell && shell.title || '').toLowerCase();
    const handle = shell && (shell.colorHandle || shell.handle) || '';
    const c = shell ? shellColorList(shell) : [];
    // Red, White & Blue: doesn't fit the three group rules — explicit mapping.
    if (handle === 'red-white-and-blue' || t.includes('red, white')) {
      return { group: 'custom', regions: { body: 'white', toe: 'blue', vamp: 'red', collar: 'red' } };
    }
    if (t.includes('glow') || handle === 'glow-in-the-dark') return { group: 'glow' };
    const hasW = c.includes('white'), hasB = c.includes('black');
    const others = c.filter(name => name !== 'white' && name !== 'black');
    if (t.includes('neon') && hasB && !hasW) return { group: 'black', accent: 'neon' };
    if (hasW && !hasB && others.length === 1) return { group: 'white1', accent: others[0] };
    if (hasW && hasB && others.length === 0) return { group: 'white1', accent: 'black' };
    if (hasW && hasB && others.length === 1) return { group: 'white2', accent: others[0] };
    if (!hasW && hasB && others.length === 1) return { group: 'black', accent: others[0] };
    return { group: 'other' };
  }

  // -> { body, toe, vamp, collar, insert, lace } hex. Insert is always white;
  // lace is the shopper's chosen lace color (falls back to white).
  function shoeRegionColors(shell, laceHex) {
    const g = classifyShell(shell);
    const hex = name => swatchColors[name] || name;
    let r;
    if (g.group === 'custom') r = { body: g.regions.body, toe: g.regions.toe, vamp: g.regions.vamp, collar: g.regions.collar, insert: 'white' };
    else if (g.group === 'white1') r = { body: 'white', toe: g.accent, vamp: g.accent, collar: g.accent, insert: 'white' };
    else if (g.group === 'white2') r = { body: 'white', toe: g.accent, vamp: 'black', collar: 'black', insert: 'white' };
    else if (g.group === 'black') r = { body: 'black', toe: g.accent, vamp: g.accent, collar: g.accent, insert: 'white' };
    else if (g.group === 'glow') r = { body: 'neon', toe: 'neon', vamp: 'neon', collar: 'neon', insert: 'white' };
    else {
      const names = shell ? shellColorList(shell) : [];
      const nonWhite = names.filter(name => name !== 'white' && name !== 'glow' && name !== 'silver');
      const acc = nonWhite[0] || 'black';
      const bodyName = names.includes('white') || names.includes('silver') ? 'white' : (names[0] || 'white');
      r = { body: bodyName, toe: acc, vamp: nonWhite[1] || acc, collar: nonWhite[1] || acc, insert: 'white' };
    }
    return {
      body: hex(r.body), toe: hex(r.toe), vamp: hex(r.vamp),
      collar: hex(r.collar), insert: hex(r.insert),
      lace: laceHex || swatchColors.white
    };
  }

  // Traced hi-top, viewBox 0 0 688 1024. Anchor = sole-bottom-center so the shoe
  // sits on the ground with the stand leg entering the collar.
  const SHOE_ANCHOR_X = 350;
  const SHOE_ANCHOR_Y = 792;
  // Tilt each shoe toe-out so it sits planted against the splayed stand leg
  // instead of dead-vertical. Rotation pivots on the sole-bottom anchor (so the
  // contact point stays pinned) and the left foot's mirror makes it symmetric.
  // 0 = upright; more negative = more toe-out. Tune here.
  const FOOT_TILT_DEG = 0;
  const SHOE_PATHS = '<path class="bagb-shoe__insert" d="m179.05 418.91c-0.69654-3.8976-3.4413-15.913-6.0996-26.7-3.8931-15.799-5.2698-19.943-7.0784-21.307-2.1514-1.6228-2.1754-1.8004-0.57293-4.246 1.3875-2.1176 5.5498-3.8248 24.435-10.022 41.509-13.621 70.277-21.639 77.642-21.639h4.2443l4.1279 9.75c2.2704 5.3625 5.2733 12.335 6.6733 15.495l2.5453 5.7449-7.2351 3.6392c-9.725 4.8916-15.617 8.7356-31.322 20.436-24.159 17.998-42.679 29.038-56.949 33.947-8.8813 3.0556-8.96 3.0171-10.41-5.0989z"/><path class="bagb-shoe__toe" d="m400.5 753.95c-21.27-2.1862-56.378-10.598-59.249-14.196-0.55051-0.68995-1.8308-5.5295-2.845-10.754-2.2543-11.614-2.6488-43.041-0.58683-46.75 1.9033-3.4238 4.8155-2.7884 7.6262 1.6641 5.2364 8.295 11.107 9.3062 19.692 3.3917 2.9492-2.0318 6.8875-4.7318 8.7518-6 4.2786-2.9106 8.5004-2.9382 22.11-0.14435 25.28 5.1894 64.271 1.0352 95.117-10.134 28.982-10.495 41.399-31.574 31.233-53.027-1.694-3.575-4.4843-8.2411-6.2006-10.369-3.4177-4.2374-3.3164-5.6309 0.40915-5.6309 7.2625 0 22.541 24.269 31.006 49.252 4.6898 13.841 6.7428 24.721 6.8397 36.248 0.0804 9.5729-0.0762 10.336-3.6685 17.871-11.081 23.243-42.991 40.186-88.736 47.117-12.592 1.9078-48.792 2.7686-61.5 1.4625zm-228.5-145.27c-7.5881-5.9602-17.502-16.998-21.718-24.179l-3.5222-6 0.50618-31.5c0.55008-34.232 1.2871-39.57 7.3198-53.013 4.7178-10.513 7.1221-7.5848 3.9977 4.8683-4.0935 16.316-2.9854 24.973 5.2666 41.144 6.0022 11.763 9.9629 22.469 12.578 34 2.5621 11.299 6.652 37.061 6.0408 38.05-1.2572 2.0343-5.205 0.76279-10.469-3.3718z"/><path class="bagb-shoe__lace" d="m434.77 121.94c-12.64 0.23453-16.999 14.377-24.455 22.576-21.367 31.304-37.193 67.083-48.025 103.44-1.1974 8.6134-6.0835-1.5397-10.95-2.3613-5.8556-6.5778-16.43-9.816-25.549-10.162-11.683-2.5536-27.108-0.78019-35.795 7.1621-12.169 6.0832-19.324 22.817-23.42 36.215 0.32599 9.69-4.4338 18.508-1.4668 28.529-0.40259 9.2984 3.9447 18.954 5.48 27.508 2.1298 6.5024 6.4279 11.639 7.8753 17.766 10.657 25.4 21.814 50.903 34.731 75.205-2.608 9.159-7.3348 14.927-16.729 17.209-18.963 8.7769-38.701 16.264-56.525 27.213-3.4736 5.8769-14.278 34.869-0.41975 27.596 6.2318-4.6692 12.22-9.722 18.232-14.16 15.206-9.2495 35.119-13.756 52.184-21.299 9.7098-1.3361 26.742-15.955 31.578-2.877 8.0572 14.747-7.2566 23.702-17.555 30.715-16.582 3.6771-33.843 8.8066-48.928 15.34-4.7569 0.71666-9.5535 4.1847-14.562 5.5934-8.3911 3.5087-10.516 18.891-2.3155 23.72 7.6804 0.64685 12.295-7.6556 19.48-7.9448 5.9867-4.9879 21.439-7.2782 6.449 0.1777-3.456 4.6603-6.7465 9.7692-9.2751 14.2-2.7973 5.8211-1.5276 17.247 6.9218 18.631 9.7995-0.33697 8.691-12.95 16.334-14.039 6.4802-4.0389 10.498-11.367 16.853-16.161 10.172-7.0005 15.157-22.054 28.517-22.267 10.847-6.0859 15.377-0.23298 18.788 10.236-16.529 4.943-34.488 14.575-47.822 27.106-6.5088 4.2294-9.758 12.05-15.262 17.795-2.0195 4.4822-4.6114 9.3051-3.5174 14.838-0.16486 6.0812 10.299 6.1221 12.213 1.8163 6.7653-1.7838 30.254-28.98 16.73-5.5782-0.50996 4.9941-1.8328 10.317-0.29065 15.215 6.1681 11.403 19.269-1.834 22.798-10.398 6.5728-6.129 7.8679-11.996 14.51-17.639 4.9997-2.656 12.753-19.496 16.928-12.324 9.4327 8.9112 2.1284 16.972-8.1172 22.271-9.1183 7.4536-18.678 17.66-21.973 28.691-2.8286 2.4946-4.6591 14.205 3.0372 16.373 8.9399-0.50869 14.684-8.617 20.822-15.492 7.1172-5.3643 11.743-12.515 19.418-17.608 10.094-14.226 13.91 21.526 28.016 14.757 12.769-9.8968-22.513-28.881 1.6924-31.317 11.331-4.6532 22.823-8.5838 34.467-10.285 6.5143-0.27058 12.045 3.5205 17.801 6.6875 5.6382 1.4705 8.9572 6.8612 14.613 8.4901 9.9085 7.4218 21.931-0.31086 23.527-12.98 3.0207-14.009-16.939-19.959-25.435-27.406-21.018-16.063-44.567-28.472-63.94-46.503-12.575-8.8232-22.554-22.172-36.163-30.118-11.19-9.7368-9.1022-24.759-16.629-35.674-9.3748-4.9991-4.9563-19.397-7.1199-28.118 0.55912-10.492-1.6068-18.635 2.0572-28.459-0.87934-9.1246 6.3093-18.373 4.6778-27.757 5.1226-17.351 5.3415-36.905 2.2539-54.994-0.76217-7.5865 3.3011-15.116 5.4277-22.221 5.318-22.63 17.338-43.866 26.271-65.93 4.2252-11.465 13.57-22.504 17.783-34.471 7.8781-10.246 15.14-22.314 20.902-34.09-1.6406-1.0023-4.5464-2.0722-7.1326-2.4369zm-82.516 471.33c-6e-3 -1e-3 1e-3 6e-3 0 0zm70.146-443.3c-0.13228 0.0592-0.0174-0.0185 0 0zm-131.91 93.523c5e-3 -3e-3 9.5e-4 0.0115 0 0zm2e-3 6e-3c4e-3 -3e-3 2e-3 7e-3 0 0zm2e-3 4e-3c6e-3 -1e-3 -1e-3 6e-3 0 0zm34.99 7.6738c0.20982 0.37807-0.15472-0.027 0 0zm-8.9629 0.4707c15.281-1.7189 30.443 9.0348 36.119 22.645-1.8005 15.187-7.9304 30.887-7.0922 45.906-2.6253 8.91-3.5739 21.175-2.9239 31.488-1.382 10.103-0.2872 19.81-4.0272 30.147-3.3325 10.051-1.8598 31.058-4.8883 35.16-10.449-11.258-16.802-27.317-24.889-39.092-4.8998-13.208-14.131-24.086-18.42-37.402-6.1914-11.026-9.6022-24.176-9.873-36.225-2.2183-19.524 7.1425-41.875 25.275-50.869 3.4435-1.1795 7.0882-1.708 10.719-1.7573zm19.498 3.1113c0.26428 0.28771-1.5113 0.34645 0 0zm33.717 16.871c0.0106 0.0668-0.0726 0.0944 0 0zm-36.115 184.44c0.115 0.0313 9e-3 0.0311 0 0zm0.11719 0.0469c0.0431 1e-3 0.0275 0.0229 0 0zm83.078 28.652c0.0996 0.0392-0.28016-0.0144 0 0zm-32.268 13.865c14.762 4.0379-3.3566 16.179-8.1035 14.795-11.101-15.116-1.2082-9.9096 8.1035-14.795zm24.148 34.484c0.35961 0.24104 0.0105 0.11666 0 0zm1.2109 0.19141c5.8088-1.4216 29.292 1.789 22.458 7.4129-11.701 0.52352-27.108 14.236-34.958 10.979-2.8866-5.689-6.6267-10.722-10.237-15.656 6.1949-3.9916 15.785-0.41977 22.737-2.7364zm-119.29 22.309c-0.16437 0.14999-1.032 0.0841 0 0zm130.32 9.9043-2e-3 0.01zm-123.61 8.0996c0.29256-0.0266-0.1042 0.0622 0 0zm76.424 26.842c0.22274 0.0339-0.0673 0.0349 0 0zm-26.955 6.6152c0.33809 0.25976-0.0102 0.19214 0 0z"/><path class="bagb-shoe__vamp" d="m329.34 734.85c-21.149-11.204-45.642-28.859-66.585-47.997-4.8125-4.3978-8.75-8.6617-8.75-9.4753s3.7583-8.3187 8.3519-16.678c4.5935-8.3593 12.328-22.624 17.188-31.699 18.825-35.153 27.338-47.2 41.682-58.985 5.4731-4.4966 10.201-7.9253 10.507-7.6194s0.0937 1.1295-0.47142 1.8303c-2.4813 3.0767-10.257 19.068-10.257 21.095 0 3.1739 2.3704 6.153 6.4279 8.0784 5.3387 2.5334 8.8626 0.56436 16.119-9.0064 3.291-4.3408 8.6404-11.13 11.887-15.087 6.6228-8.071 6.5466-8.0631 13.047-1.3553l3.9814 4.1083-6.05 5.3892c-3.3275 2.9641-8.4616 8.9134-11.409 13.221-2.9475 4.3074-6.7202 9.002-8.3838 10.432-7.5158 6.4622 0.35465 18.521 9.7554 14.947 1.4975-0.56933 7.6859-5.9879 13.752-12.041s11.278-11.006 11.582-11.006c0.30385 0 0.30256 1.54-3e-3 3.4222-0.38846 2.3938-5.8197 10.404-18.073 26.657-9.635 12.779-19.231 26.612-21.326 30.739-3.5748 7.0458-3.8082 8.0591-3.8206 16.593-7e-3 4.999-0.44392 9.764-0.97026 10.589-1.8402 2.8844-1.8905 33.061-0.0737 44.213 0.92171 5.6577 1.9045 11.074 2.1839 12.037 0.7937 2.7338-1.6954 2.1533-10.292-2.4005zm161.35-146.89c-2.5413-2.2369-5.8734-6.4049-7.4046-9.2621-3.4674-6.4702-6.5771-8.0913-19.803-10.323-8.3272-1.4054-10.593-2.197-13.676-4.778-2.0321-1.7014-3.3804-3.4103-2.9962-3.7974 0.3842-0.38709 4.0718-1.1225 8.1947-1.6342l7.4962-0.93037 12.26 7.1342c9.361 5.4474 12.403 7.7253 12.866 9.6342 0.33327 1.375 2.3681 5.8233 4.5219 9.8852 2.1538 4.0618 3.7463 7.5548 3.539 7.7621-0.20732 0.20731-2.4562-1.4533-4.9975-3.6902zm-75.425-48.68c-2.8803-3.1002-5.1186-5.755-4.9741-5.8996s3.9516-0.35171 8.4602-0.46038c8.0083-0.19301 8.326-0.109 13.772 3.6415l5.5741 3.839-6.7974 1.6252c-3.7386 0.89388-7.6974 1.91-8.7974 2.2581-1.5478 0.48978-3.1839-0.64148-7.2369-5.0039z"/><path class="bagb-shoe__collar" d="m386 607.72c-5.2314-1.1574-5.4926-1.3634-5.348-4.2169 0.47681-9.408 1.4079-11.395 8.2217-17.545 3.6292-3.2754 7.0547-5.9518 7.6123-5.9474 0.55763 4e-3 3.4889 3.1986 6.5139 7.0982 6.923 8.9246 10.407 11.894 13.954 11.894 6.9223 0 6.4532-5.5-1.5114-17.719-3.0654-4.7028-5.2066-8.9036-4.7582-9.3352 1.4353-1.3813 17.553-7.6918 25.583-10.016 8.5773-2.4828 9.4731-2.3101 15.304 2.9518 4.7643 4.2992 6.4279 7.2358 6.4279 11.346 0 3.5097-0.48706 4.1432-6.75 8.7798-7.5634 5.5994-20.969 12.76-35.377 18.897-10.985 4.6789-20.48 5.8907-29.873 3.8126zm-18.787-40.886-5.2506-5.0087 3.93-4.6612c2.1615-2.5636 5.4867-6.1556 7.3895-7.982l3.4595-3.3209 4.1293 7.5238c2.2711 4.1381 4.1293 7.9528 4.1293 8.4771 0 0.77182-6.7034 6.1975-11.503 9.3108-0.56809 0.36846-3.3957-1.584-6.2835-4.3388zm25.351-21.353c-3.0605-5.1285-5.5645-9.7442-5.5645-10.257 0-0.95923 10.068-2.2019 17.942-2.2145 4.0938-7e-3 4.8596 0.43064 9.7602 5.5718 4.8212 5.0578 5.8472 7.4211 3.222 7.4211-0.52653 0-5.196 1.9807-10.376 4.4016l-9.4192 4.4016zm-81.599-3.0286-3.2156-4.6737 27.314-27.366 21.148-5.1957 3.4291 7.5247c1.886 4.1386 3.3009 7.6297 3.1443 7.758s-2.7598 1.0281-5.7848 1.9995c-11.886 3.8167-23.75 10.557-41.041 23.315-1.5799 1.1658-2.1358 0.7916-4.9934-3.3618zm-129.44-17.565c-5.3231-4.6738-14.407-18.983-17.241-27.157-2.4795-7.1532-2.5037-7.5446-2.3274-37.705 0.12723-21.772 0.51632-30.885 1.3622-31.907 1.5947-1.9261 14.766-8.1835 15.835-7.5228 0.46714 0.28871 0.84935 1.6234 0.84935 2.9659 0 3.042 1.7028 3.1236 9.4642 0.45329 14.269-4.9094 32.79-15.949 56.949-33.947 15.722-11.713 21.596-15.544 31.37-20.46l7.2825-3.663 4.0485 8.7789c2.2267 4.8284 5.1874 11.479 6.5794 14.779s6.0153 13.246 10.274 22.103c6.9856 14.527 7.6211 16.337 6.4958 18.5-0.68606 1.3184-1.7927 4.2285-2.4593 6.4668l-1.2119 4.0696-22.146 9.8486c-27.308 12.144-43.561 20.082-46.001 22.466-2.6291 2.5686-7.8538 23.365-6.6593 26.507 0.61872 1.6274 0.52689 2.689-0.28919 3.3434-2.4502 1.9647-11.36 5.9226-16.196 7.1941-8.0238 2.1099-19.732 6.9617-23.251 9.6354-1.7881 1.3584-3.9371 3.7966-4.7757 5.4182-1.9367 3.7451-3.5344 3.7116-7.9515-0.16675zm191.54-15.557c-1.7172-3.6696-2.7721-6.9822-2.3443-7.3612 0.42789-0.37903 3.6582-1.3934 7.1784-2.2542l6.4004-1.565 7.6475 6.1457-4.6596 4.1034c-6.6694 5.8733-8.9681 7.6034-10.102 7.6034-0.54891 0-2.403-3.0024-4.1202-6.672zm-92.66-16.893c-2.9983-6.3565-5.5537-12.454-5.6788-13.55-0.1963-1.7208 2.5725-3.0557 20.273-9.7733 11.275-4.2792 22.581-8.7046 25.125-9.8343 5.9269-2.632 18.871-4.9005 19.76-3.4629 0.35208 0.56969 1.7196 5.3353 3.0388 10.59l2.3987 9.5544-2.89 2.2708c-1.5895 1.2489-6.0549 5.0409-9.9232 8.4267-6.4592 5.6535-7.7259 6.3206-15.521 8.1728-6.7932 1.6141-19.873 5.4431-29.809 8.7266-0.86868 0.28706-3.1885-3.522-6.7726-11.121zm49.108-79.077c-5.5068-6.7602-6.7662-8.8744-20.023-33.614-5.6714-10.584-9.9851-19.588-9.586-20.009 1.6307-1.7198 15.863-3.9004 22.733-3.483 8.4666 0.51427 12.609 2.6016 16.692 8.41l2.8575 4.0657-1.6138 7.9125c-2.3315 11.431-4.5313 28.875-4.5539 36.11-0.0107 3.4375-0.4448 6.25-0.96458 6.25s-3.0133-2.539-5.5412-5.6423z"/><path class="bagb-shoe__body" d="m427.11 799.86c-27.051-2.8277-53.808-11.846-84.607-28.518-26.668-14.435-47.662-29.47-79.763-57.123-23.306-20.076-33.256-27.956-60.237-47.704-26.518-19.41-32.101-23.881-42.752-34.243-10.448-10.164-11.179-12.74-12.053-42.499-0.14107-4.8018-2e-3 -8.4018 0.30806-8 0.31051 0.40181 2.3493 3.4099 4.5306 6.6846 4.8214 7.2383 15.378 17.974 21.96 22.335 5.3658 3.5542 5.3993 3.5643 7.4597 2.261 1.266-0.80085 1.2251-2.3841-0.31622-12.235-4.7002-30.039-8.077-41.774-17.441-60.606-6.5366-13.147-6.6132-13.396-7.0294-22.913-0.39264-8.9774 1.0602-19.61 3.8664-28.296 0.73439-2.2731 0.81487-2.3045 0.88665-0.34579 0.40247 10.982 18.128 39.346 24.588 39.346 0.79173 0 2.1256-1.3267 2.9642-2.9483 0.83854-1.6216 2.9876-4.0598 4.7757-5.4182 3.5183-2.6729 15.223-7.524 23.251-9.6363 7.728-2.0334 20.479-8.9545 26.5-14.384 5.9802-5.3925 16.337-12.385 23.062-15.569l6.4383-3.0491 0.94495 2.2525c0.51973 1.2389 3.3114 7.3371 6.2038 13.552 3.5157 7.5538 4.8598 11.439 4.055 11.721-17.991 6.3036-22.068 8.1069-27.454 12.145-3.1538 2.3646-3.25 2.6554-3.25 9.8291 0 6.336 0.29505 7.5991 2.0647 8.8386 2.4848 1.7404 4.8347 1.2393 11.435-2.4384 5.0827-2.832 16.965-8.0414 21.491-9.4221 2.0058-0.61189 1.3417 0.48138-3.4102 5.614-7.5925 8.2008-12.049 17.387-11.266 23.224 0.60506 4.5111 4.2904 8.6894 7.6642 8.6894 2.6838 0 7.7839-4.615 10.085-9.1258 1.0871-2.1308 2.6693-3.8742 3.516-3.8742 0.84675 0 3.9473-2.2772 6.8901-5.0604l5.3506-5.0604 6.3203 9.1862-4.9364 5.7172c-7.9766 9.2384-12.478 17.004-12.999 22.426-0.28735 2.9905 8e-3 5.3451 0.78975 6.2865 1.626 1.9592 8.3797 1.9627 10.004 5e-3 0.68469-0.825 1.6505-1.5 2.1462-1.5s-1.539 3.2625-4.5217 7.25c-6.9003 9.225-13.958 20.972-25.085 41.75-4.8597 9.075-12.594 23.339-17.188 31.699-4.5935 8.3595-8.3519 15.865-8.3519 16.678 0 2.7832 25.274 24.613 43.462 37.539 15.549 11.051 37.772 24.084 41.066 24.084 0.7468 0 2.846 0.87802 4.665 1.9512 4.9574 2.9247 25.554 8.5472 40.807 11.139 18.263 3.1037 61.037 3.4294 78.904 0.60072 33.653-5.328 59.78-15.881 75.103-30.336 8.658-8.1675 12.794-14.604 15.578-24.243l2.1982-7.6118 0.85891 7c1.4312 11.664 0.96697 29.253-0.96338 36.5-8.1636 30.65-33.317 51.683-74.178 62.026-17.846 4.5172-35.759 5.7788-54.393 3.831zm-76.26-109.83c-0.90906-0.56221-3.2708-3.2743-5.2483-6.0269s-4.2437-5.0047-5.0359-5.0047c-1.8456 0-3.0344-7.4756-2.199-13.828 1.0292-7.8262 6.9443-17.755 24.419-40.986 13.987-18.596 16.805-21.854 17.258-19.955 0.43858 1.8415 1.6645 2.5107 6.5 3.5481 9.4228 2.0216 18.236 0.85204 29.395-3.9008 14.348-6.1113 27.762-13.279 35.315-18.87 6.2629-4.6366 6.75-5.2701 6.75-8.7798 0-2.0804-0.7209-4.8118-1.602-6.0698-0.8811-1.258-1.4037-2.4855-1.1614-2.7278 0.83529-0.83528 18.271 2.6604 21.763 4.3634 2.2755 1.1095 4.3894 3.3559 6.0422 6.4209 3.629 6.7298 6.2428 9.2296 16.958 16.219 11.167 7.284 17.777 14.254 22.215 23.426 2.7998 5.7864 3.2122 7.6696 3.2056 14.641-6e-3 6.8201-0.43623 8.8595-2.9146 13.828-5.4783 10.982-18.335 20.276-36.006 26.028-30.544 9.9425-64.953 13.329-88.5 8.71-5.775-1.1328-13.031-2.061-16.125-2.0627-5.2563-3e-3 -6.1298 0.36585-13.338 5.6297-7.9866 5.8325-14.015 7.6722-17.69 5.3989zm-6.2295-77.849c-1.6767-2.6963-1.0677-8.1767 1.1557-10.4 2.5568-2.5568 3.8764-1.8647 2.2476 1.1787-0.62761 1.1727-1.4657 4.0237-1.8624 6.3356-0.47747 2.7823-0.99839 3.7579-1.5408 2.8857zm-22.061-22.405c-1.9682-2.81-1.9784-6.0612-0.031-9.8272 0.83912-1.6227 1.6266-2.9503 1.75-2.9503s0.22432 3.375 0.22432 7.5-0.087 7.5-0.1933 7.5c-0.10631 0-0.89381-1.0001-1.75-2.2225z"/>';

  const FOOT_SCALE = 0.086;
  // Sandal + Sasquatch have their own traced art, drawn in the same 688x1024
  // space with their own sole-bottom-center anchors and sizes.
  const SANDAL_ANCHOR_X = 366, SANDAL_ANCHOR_Y = 785, SANDAL_SCALE = 0.065;
  // Sandal has its own tilt and right-foot tip x (left mirrors it around center).
  const SANDAL_TILT = -5;
  const SANDAL_FOOT_X = 192;
  const SASQUATCH_ANCHOR_X = 338, SASQUATCH_ANCHOR_Y = 905;
  // Sasquatch is tuned on its own: non-uniform scale (squashed a touch
  // vertically), its own tilt, and its own right-foot tip x (left mirrors it
  // around the 220-wide bag center). Shoe/sandal keep the shared FOOT_ values.
  const SASQUATCH_SCALE_X = 0.057, SASQUATCH_SCALE_Y = 0.053;
  const YETI_ART_COLORS = '--sq-skin:#94ccf2;--sq-fur:#f3f5f2;--sq-sole:#eef1f0';
  const SASQUATCH_TILT = 5;
  const SASQUATCH_FOOT_X = 191;

  // Preview shading ("Overlay+ white-safe"): a light->dark gradient clipped to
  // each foot's silhouette (mix-blend-mode overlay for colour pop) plus a
  // multiply shadow so white shells gain depth too. Tuned: light from 245deg,
  // 85% strength. Set SHADE_STRENGTH = 0 to turn shading off.
  const SHADE_ANGLE = 245, SHADE_STRENGTH = 0.85;
  const _sr = SHADE_ANGLE * Math.PI / 180, _ssx = Math.sin(_sr), _ssy = -Math.cos(_sr);
  const SHADE_X1 = 0.5 + 0.5 * _ssx, SHADE_Y1 = 0.5 + 0.5 * _ssy;
  const SHADE_X2 = 0.5 - 0.5 * _ssx, SHADE_Y2 = 0.5 - 0.5 * _ssy;
  const SHADE_AL = (0.40 * SHADE_STRENGTH).toFixed(3);
  const SHADE_AD = (0.50 * SHADE_STRENGTH).toFixed(3);
  const SHADE_BD = (0.30 * SHADE_STRENGTH).toFixed(3);
  let feetShadeSeq = 0;
  const SANDAL_PATHS = '<path class="bagb-sandal__insert" d="m 129.61733,260.25 c -2.29511,-11.65398 -2.44394,-11.00885 6.21605,-26.94598 4.42434,-8.14221 8.5525,-15.95038 9.17368,-17.35149 0.92818,-2.09358 0.40456,-5.83916 -2.93882,-21.02219 -4.57085,-20.75719 -4.72796,-22.5156 -2.29424,-25.67698 1.48725,-1.93191 5.02142,-2.87631 25.22777,-6.74137 12.92403,-2.47211 23.94823,-4.47936 24.49823,-4.46057 0.55,0.0188 -3.47517,1.57423 -8.94481,3.45654 -5.46965,1.88231 -11.99465,4.475 -14.5,5.76154 -7.06112,3.62598 -7.23179,4.59289 -7.99307,45.28376 -0.63694,34.04432 -0.72068,35.15821 -2.90937,38.69959 -2.65389,4.29408 -6.79474,7.0436 -14.70821,9.76623 -8.04793,2.7689 -10.15999,2.61887 -10.82721,-0.76908 z"/><path class="bagb-sandal__strap" d="m 460.5,593.17582 c -11.05174,-11.76175 -36.97788,-29.50041 -58,-39.68358 -11.066,-5.36039 -25.03,-10.11906 -38,-12.94967 -12.06987,-2.63416 -42.47784,-7.34898 -55.60714,-8.62201 -26.54015,-2.57335 -46.54294,3.5571 -57.02417,17.47677 -5.32357,7.07 -7.34962,14.19247 -7.17685,25.22981 0.13881,8.86768 0.0706,9.16008 -2.40048,10.28597 -4.24527,1.93427 -8.29806,-0.15945 -11.98201,-6.19004 -1.75486,-2.87269 -6.09817,-8.5051 -9.65181,-12.51647 l -6.46116,-7.2934 -0.66735,-12.2066 c -1.36921,-25.04441 4.94227,-45.31434 16.00414,-51.39882 4.46313,-2.45491 19.6231,-6.47158 31.96683,-8.4697 4.75223,-0.76926 16.52539,-1.28934 29,-1.28108 19.09417,0.0127 22.17272,0.26395 33.92196,2.76906 7.10708,1.51533 20.83208,5.39921 30.5,8.63085 20.87206,6.97677 28.13486,8.53111 36.01431,7.70754 11.24517,-1.17535 16.66557,-5.08365 33.45874,-24.1249 26.43653,-29.97557 32.62259,-39.42034 35.11899,-53.61916 1.62274,-9.22971 3.74506,-14.1924 7.24771,-16.94759 5.82106,-4.57885 10.33055,-1.97904 29.80529,17.18331 9.06999,8.92449 16.74398,17.23476 17.05332,18.46727 0.39652,1.57986 -1.82801,6.84422 -7.54093,17.84565 -13.05689,25.14376 -21.70911,38.1447 -34.95975,52.53097 -3.2928,3.575 -7.47927,8.96203 -9.30327,11.97117 l -3.31637,5.47118 0.0968,13.52882 c 0.085,11.89046 0.60201,15.87794 4.26886,32.92664 2.29466,10.66879 4.05111,19.45758 3.90324,19.53064 -0.14787,0.0731 -2.96886,-2.74062 -6.26886,-6.25263 z"/><path class="bagb-sandal__foot" d="m 428,705.60395 c -25.10776,-3.87678 -51.32402,-13.18688 -67.91951,-24.12004 -3.99877,-2.6344 -12.34522,-9.60721 -18.54766,-15.49512 -12.84438,-12.19303 -19.0283,-16.81107 -37.74757,-28.18918 -22.8193,-13.87023 -34.80172,-23.98117 -48.3514,-40.79961 -10.78673,-13.38894 -10.63607,-13.06972 -10.7633,-22.80593 -0.31522,-24.12207 14.39756,-38.7194 42.68161,-42.34669 10.71123,-1.37366 24.76791,-0.23306 52.13998,4.23078 22.06566,3.59846 29.16583,5.12622 42.00785,9.03889 24.31285,7.40756 62.30907,30.51133 79.25,48.1883 3.4375,3.58685 6.25,6.36144 6.25,6.16577 0,-0.19568 -1.86896,-9.04423 -4.15324,-19.66345 -3.64726,-16.9555 -4.16502,-20.95583 -4.25,-32.8365 l -0.0968,-13.52882 3.31637,-5.47118 c 1.824,-3.00914 6.01686,-8.39617 9.31745,-11.97117 12.24583,-13.2639 22.02436,-27.69236 32.86967,-48.5 5.72387,-10.98172 6.07314,-11.55377 5.40277,-8.84891 -0.33788,1.36324 2.59477,4.60701 11.16449,12.34891 16.82092,15.19604 52.61118,51.91535 62.10026,63.71225 4.48229,5.57242 9.96905,13.24697 12.1928,17.05456 12.00582,20.55681 10.55282,48.40072 -2.92589,56.06896 -1.69242,0.96284 -2.93029,2.50713 -2.93717,3.66423 -0.0231,3.88169 -2.10801,9.47402 -4.66497,12.5128 -3.15662,3.75142 -9.24552,6.9872 -13.14811,6.9872 -2.79173,0 -2.9306,0.23282 -4.00462,6.71434 -1.68138,10.14682 -6.96235,15.65688 -16.17753,16.87932 l -4.75349,0.63057 -0.59104,4.99034 c -1.72347,14.55202 -13.47822,20.88363 -35.85552,19.31332 l -9.69454,-0.68031 -2.46597,4.86635 c -4.76792,9.40904 -16.42192,17.29823 -30.73316,20.80485 -8.79444,2.15486 -28.4364,2.70264 -38.9118,1.08517 z M 241,585.60699 c 0,-0.21616 0.69837,-0.661 1.55194,-0.98855 0.88992,-0.34149 1.29132,-0.17385 0.94098,0.39301 C 242.90566,585.96166 241,586.4169 241,585.60699 Z M 225.87244,573.25 c -1.24387,-1.58606 -1.2085,-1.62143 0.37756,-0.37756 0.9625,0.75485 1.75,1.54235 1.75,1.75 0,0.82304 -0.82119,0.29331 -2.12756,-1.37244 z m -4.46745,-5.5 -1.90499,-2.25 2.25,1.90499 c 2.11444,1.79022 2.70524,2.59501 1.90499,2.59501 -0.18976,0 -1.20226,-1.0125 -2.25,-2.25 z m -8.15281,-17.25 c 0.0111,-2.2 0.21589,-2.98225 0.45508,-1.73834 0.23919,1.24391 0.23011,3.04391 -0.0202,4 -0.25029,0.95609 -0.446,-0.0617 -0.4349,-2.26166 z m -11.62952,-22.33618 c -5.98254,-5.62647 -15.55719,-13.85398 -21.27701,-18.28335 -18.32279,-14.18898 -30.32531,-27.12299 -42.53391,-45.83486 -10.51676,-16.11883 -11.28719,-18.62923 -11.21558,-36.54561 0.046,-11.49976 0.90166,-21.06709 3.66705,-41 1.9839,-14.3 4.34216,-32.64749 5.24056,-40.77219 l 1.63345,-14.7722 -3.50504,-9.85621 C 129.21297,308.67255 127.56485,295.14987 128.9887,283 c 0.54787,-4.675 0.99954,-11.0875 1.00371,-14.25 0.007,-5.36208 0.16569,-5.75 2.35104,-5.75 3.15625,0 13.07188,-3.47554 17.20724,-6.03133 1.84167,-1.13821 4.3626,-3.71033 5.60206,-5.71582 2.18869,-3.54138 2.27243,-4.65527 2.90937,-38.69959 0.77496,-41.42193 0.82463,-41.68182 8.71923,-45.62288 7.85171,-3.91964 26.06935,-9.50972 40.21865,-12.34108 38.84348,-7.7728 94.41373,-17.06672 110.5,-18.48071 9.80674,-0.86202 18.59503,-0.34689 20.12134,1.17942 0.29813,0.29813 0.95428,6.99279 1.4581,14.87702 1.61104,25.2107 4.97313,49.07985 8.97922,63.74783 1.11352,4.07708 5.11717,13.30208 8.89701,20.5 11.84574,22.5578 14.13087,31.21495 16.11719,61.05955 1.2937,19.43811 2.81657,25.53164 9.74892,39.00904 8.85384,17.21301 14.81609,23.72414 41.67822,45.51504 7.7,6.24633 19.10082,15.88994 25.33515,21.43024 6.23433,5.5403 11.90701,10.02157 12.60595,9.95839 0.9956,-0.09 0.97017,0.48775 -0.11745,2.66793 -0.76354,1.53055 -2.02144,6.38421 -2.79534,10.7859 -2.51206,14.28795 -8.65593,23.67873 -35.1333,53.7006 -16.79317,19.04125 -22.21357,22.94955 -33.45874,24.1249 -7.87945,0.82357 -15.14225,-0.73077 -36.01431,-7.70754 -9.66792,-3.23164 -23.39292,-7.11552 -30.5,-8.63085 -11.74924,-2.50511 -14.82779,-2.75641 -33.92196,-2.76906 -12.47461,-0.008 -24.24777,0.51182 -29,1.28108 -12.34373,1.99812 -27.5037,6.01479 -31.96683,8.4697 -7.86515,4.32616 -13.47839,16.29234 -15.77983,33.6391 L 212.5,538.39376 Z M 512.08029,452 C 513.5381,448.93897 514,448.37166 514,449.6422 c 0,0.53655 -0.69982,1.84905 -1.55517,2.91667 -1.46637,1.83031 -1.48719,1.7984 -0.36454,-0.55887 z m -13.06373,-22.5 -14.48344,-15 14.93965,14.71045 c 8.21681,8.09075 14.73436,14.84075 14.48344,15 C 513.7053,444.3697 506.98245,437.75 499.01656,429.5 Z M 480.40499,411.75 478.5,409.5 l 2.25,1.90499 c 2.11444,1.79022 2.70524,2.59501 1.90499,2.59501 -0.18976,0 -1.20226,-1.0125 -2.25,-2.25 z M 125.73948,233.18988 C 124.28042,225.66045 120.59563,210.725 117.55106,200 c -3.04457,-10.725 -5.53907,-20.94993 -5.54332,-22.72207 -0.007,-3.03101 0.30356,-3.3113 5.24226,-4.72704 2.8875,-0.82774 8.4,-2.19812 12.25,-3.04529 3.85,-0.84717 8.08116,-1.7833 9.40259,-2.0803 2.35655,-0.52965 2.37092,-0.49167 0.75,1.98217 -2.2873,3.49085 -2.1841,4.57699 2.43659,25.6443 l 4.08919,18.64397 -3.50673,6.90213 c -1.92869,3.79617 -5.93055,11.26258 -8.89302,16.59201 l -5.3863,9.68988 z"/><path class="bagb-sandal__sole" d="M 436.25533,785.00884 C 400.50982,781.87728 360.96711,766.18261 328.88095,742.39148 313.59035,731.05388 299.31125,718.02938 272.9158,691.3436 256.48018,674.72721 245.1339,662.19559 235.48277,650 210.11607,617.94548 206.5669,613.72253 196,603.02174 190.225,597.17356 174.925,583.14422 162,571.84542 130.30252,544.13607 122.38772,535.6542 115.49566,522.00921 111.00082,513.11025 110.7629,511.62302 109.73529,486 108.07508,444.60388 108.08331,444.34852 111.28746,437.82377 114.16033,431.9736 122.67779,422 124.80096,422 c 0.84328,0 1.20873,2.74449 1.23169,9.25 0.0381,10.79211 1.52478,15.87535 7.90386,27.02454 10.77496,18.83221 26.0546,35.74989 48.56349,53.76972 7.15,5.72404 16.87765,14.13719 21.61699,18.69589 l 8.617,8.28855 0.47287,9.82004 0.47286,9.82003 7.41014,8.98419 c 4.07558,4.9413 8.86337,11.09083 10.63953,13.66561 2.89374,4.19486 3.62649,4.68143 7.05,4.68143 2.10134,0 4.30017,-0.47956 4.88631,-1.0657 0.75426,-0.75426 3.06908,1.51056 7.92107,7.75 8.98178,11.55016 23.04627,25.65979 32.41323,32.51728 4.125,3.01989 13.35,9.01549 20.5,13.32357 16.98159,10.23187 24.9966,16.29618 39.18006,29.64431 12.44687,11.71382 20.50687,17.06337 35.84156,23.78864 27.99402,12.27723 62.38312,17.87648 83.50583,13.59647 16.34038,-3.31098 30.97375,-12.57674 35.41302,-22.42329 L 500.07761,679.5 h 14.2112 c 12.89825,0 14.70736,-0.22404 19.58167,-2.42497 6.72721,-3.03759 10.66344,-8.21754 12.20719,-16.06428 l 1.13479,-5.76802 4.52357,-0.62003 c 9.16321,-1.25596 14.4571,-7.05948 15.82146,-17.34459 l 0.66487,-5.01203 5.67995,-1.57917 c 8.91815,-2.47946 15.06764,-9.83861 15.09211,-18.06084 0.003,-1.03066 2.04939,-3.67296 4.54739,-5.87179 5.72779,-5.0418 8.53487,-10.50837 9.20801,-17.93189 C 603.0402,585.62008 603.6037,583 604.00205,583 c 1.32518,0 9.85496,9.73667 13.2778,15.15648 5.45699,8.64076 6.99558,13.48601 6.93631,21.84352 -0.0927,13.07475 -4.31331,55.05992 -6.32615,62.93059 -12.07308,47.20865 -72.65459,91.0196 -138.89001,100.4416 -13.8529,1.97058 -31.30537,2.63882 -42.74467,1.63665 z"/>';
  const SASQUATCH_PATHS = '<path class="bagb-sq__insert" d="m584.73 240.75c-2.4089-4.5375-7.0115-12.69-10.228-18.116l-5.8482-9.8659 3.3615-18.134c4.1258-22.257 4.6975-28.798 2.6645-30.485-0.81356-0.6752-5.6868-1.6739-10.829-2.2194s-10.322-1.4822-11.51-2.0817c-1.1882-0.59945-2.8994-3.025-3.8026-5.3901-0.90325-2.3651-2.2616-4.8142-3.0186-5.4425-2.3616-1.96-18.822-4.8279-51.83-9.0303-17.496-2.2275-35.271-4.6946-39.5-5.4824-4.2289-0.78776-13.539-2.1406-20.689-3.0063-7.15-0.86572-15.925-2.2366-19.5-3.0465-6.2738-1.4212-35.036-10.317-35.947-11.117-0.24583-0.21611 0.78259-1.6168 2.2854-3.1126 2.679-2.6666 2.951-2.7154 13.923-2.5018 28.85 0.5618 130.09 14.906 169.24 23.978 13.137 3.0443 14.008 3.4516 16.119 7.5336 1.9147 3.7026 1.5451 12.529-1.6653 39.77-2.7308 23.173-2.729 23.199 1.9892 28.06 2.1685 2.2345 4.4656 5.7225 5.1046 7.7512 0.639 2.0286 2.8923 6.6134 5.0074 10.188 4.0111 6.7798 6.4323 14.89 5.4082 18.117-0.40299 1.2697-1.5354 1.8834-3.4756 1.8834-2.5839 0-3.3251-0.84246-7.2576-8.25z"/><path class="bagb-sq__skin" d="m253 804.58c-22.299-4.0253-41.976-15.816-48.836-29.262l-2.112-4.14-7.2759 2.4651c-12.988 4.4003-27.995 4.796-37.13 0.979-5.5827-2.3326-12.487-9.4299-16.777-17.247-3.9157-7.1346-3.9989-7.2087-8.8329-7.8736-11.329-1.5582-21.133-8.8172-26.632-19.719-3.0521-6.051-3.8458-6.7495-7.6937-6.7706-3.4313-0.0188-9.4636-3.0203-12.402-6.1709-2.9107-3.1205-6.9594-12.28-7.8244-17.701-0.52021-3.2602-1.9118-5.6999-5.5309-9.6962-2.6597-2.937-5.6392-6.6016-6.621-8.1437-0.98186-1.5421-2.0667-3.0288-2.4108-3.3038-2.1342-1.7056-4.4107-12.275-4.4154-20.5-0.0046-8.0666 0.29561-9.5428 2.895-14.234 1.5951-2.8786 7.4451-10.079 13-16 6.6593-7.0986 12.457-14.579 17.018-21.958 9.3289-15.091 14.221-21.459 28.952-37.685 12.747-14.041 26.319-32.699 25.155-34.583-0.35352-0.57201 0.03061-1.04 0.85363-1.04s4.05-3.0375 7.171-6.75c5.7674-6.8604 11.085-11.625 17.175-15.389 4.1671-2.5754 5.1276-1.8761 2.5151 1.8312-3.3734 4.787-6.2397 11.111-6.2397 13.768 0 1.9848 0.50345 2.5398 2.3037 2.5398 3.4111 0 11.874-4.5241 17.15-9.1677 2.5486-2.2433 4.8694-3.8431 5.1575-3.555 0.28809 0.28809-0.58193 2.706-1.9334 5.3732-3.3003 6.5135-7.9258 21.57-7.5111 24.449 0.39146 2.7181 4.1094 4.015 7.7422 2.7005 3.2295-1.1685 8.306-5.7263 14.986-13.455 3.0367-3.5134 6.5298-7.0487 7.7623-7.8563 1.9838-1.2998 1.7842-0.51639-1.7393 6.8267-2.1891 4.5622-4.25 9.9576-4.5798 11.99-0.56418 3.4766-0.44405 3.6946 2.0362 3.6946 2.7228 0 9.733-3.049 16.201-7.0463 2.037-1.2589 3.5057-1.876 3.2639-1.3713-6.3091 13.167-11.461 28.354-10.483 30.902 0.39725 1.0352 1.9711 1.5156 4.9651 1.5156 7.061 0 10.238-2.9094 16.883-15.461 3.1858-6.0173 7.2557-12.455 9.0442-14.306 4.1905-4.3369 9.4099-7.5627 10.823-6.6892 1.5857 0.98004 0.29596 6.7531-3.1603 14.146-3.1806 6.8029-3.6307 9.8201-1.5823 10.606 0.73093 0.28048 4.6684 0.14263 8.75-0.30634 4.0816-0.44898 7.5649-0.67392 7.7408-0.49989 0.17587 0.17404-0.62865 2.1755-1.7878 4.4476s-1.8072 4.6172-1.4401 5.2112c1.4597 2.3619 8.8865-0.14889 20.902-7.0663 6.7661-3.8952 12.829-7.0823 13.472-7.0823s-1.1104 4.2182-3.8979 9.3738c-3.0112 5.5693-5.0682 10.643-5.0682 12.5 0 3.3366 0.37507 3.5056 6.9504 3.1337 2.926-0.16553 3.2657 0.0273 2.2355 1.2686-0.66818 0.80511-3.9083 2.6726-7.2004 4.15s-5.9855 3.1109-5.9855 3.63c0 1.7835 12.284 0.99799 16.859-1.078 5.856-2.6572 6.1066-2.5612 4.6223 1.772-2.6435 7.7168-2.2655 10.25 1.5294 10.25 4.5394 0 11.283-3.5952 18.021-9.6074 3.324-2.9659 6.2392-5.3926 6.4782-5.3926 0.23903 0-1.0777 3.0375-2.926 6.75-4.3197 8.6765-5.1673 12.521-3.1325 14.21 3.6374 3.0187 17.587-7.202 29.971-21.96 2.077-2.475 3.4319-3.6 3.0109-2.5-1.674 4.3745-5.3332 19.162-5.382 21.75-0.0645 3.4209 2.3416 3.6685 5.6298 0.57939 1.2708-1.1938 2.5208-1.9603 2.7778-1.7033 0.257 0.257-0.19122 2.6553-0.99605 5.3295-2.0236 6.7239-1.8934 8.5444 0.61091 8.5444 2.6172 0 12.641-9.4879 17.543-16.605 2.0436-2.9672 3.9841-5.3949 4.3122-5.3949s1.0409 0.98339 1.5838 2.1853 1.4782 2.3406 2.0783 2.5304c1.1715 0.37049 12.891-9.0106 20.653-16.531 3.5979-3.4864 5.0239-4.3166 5.9034-3.4371 0.69666 0.69666 1.5374 7.6662 2.1056 17.456 1.0332 17.798 1.9718 20.713 5.6095 17.421 1.0585-0.95793 2.9402-4.9778 4.1815-8.9332 2.5505-8.1268 6.7601-17.696 7.7788-17.683 0.37256 5e-3 2.4107 2.699 4.5292 5.9872 3.671 5.6978 3.8954 6.5247 4.7818 17.616 1.2656 15.838 2.6927 18.058 8.2785 12.882 5.1767-4.7976 9.4301-17.243 9.6995-28.38l0.11159-4.6135 1.6576 6.99c1.9434 8.1954 3.6942 9.2119 8.3572 4.8524 5.5464-5.1854 14.762-28.948 14.762-38.065 0-3.2656 2.6525-9.2775 4.0933-9.2775 0.87062 0 1.0423 2.0242 0.63185 7.451-0.58233 7.6997-0.12532 11.549 1.3712 11.549 1.0261 0 3.773-5.1207 9.613-17.92 2.364-5.1812 4.5414-9.6636 4.8387-9.9609 0.29728-0.29729 1.5736 0.75515 2.8364 2.3388 3.8793 4.8651 4.69 3.8507 14.996-18.764 1.9752-4.3342 4.1262-7.6935 4.9263-7.6935 0.92756 0 1.8615 2.0793 2.6923 5.994 0.6996 3.2967 1.8178 6.7404 2.4849 7.6528 3.316 4.535 5.3858-3.7792 6.5532-26.325 0.8804-17.002 2.5976-25.284 4.9421-23.835 0.59892 0.37015 1.0273 5.4638 1.0363 12.322 0.0173 13.184 0.9117 16.017 3.9246 12.429 2.4708-2.942 3.8176-9.4637 4.6667-22.598 0.47517-7.3497 1.0664-10.64 1.9118-10.64 0.71886 0 1.5068 2.1325 1.9094 5.1678 0.85667 6.4579 3.1675 12.134 4.7282 11.613 1.6614-0.55382 5.1747-10.388 8.4364-23.615 2.2872-9.275 3.0461-11.12 4.3397-10.551 0.86229 0.37919 2.9428 0.88489 4.6234 1.1238 4.969 0.7063 5.8667-1.3853 5.9082-13.765 0.0199-5.9433 0.37183-11.142 0.782-11.552 1.7094-1.7109 5.6532 1.5189 6.4503 5.2824 1.6249 7.6721 0.89599 23.358-1.4309 30.796-7.0098 22.405-31.6 58.663-63.485 93.605-16.098 17.642-23.263 26.465-29.966 36.902-6.5952 10.269-26.79 45.372-39.097 67.958-10.334 18.965-14.004 24.203-22.839 32.592-8.9771 8.525-15.74 12.99-37.378 24.676-15.215 8.2171-20.006 12.188-32.832 27.209-17.822 20.873-27.004 29.097-41.689 37.343-6.5457 3.6753-21.351 8.7799-31.338 10.805-10.347 2.0978-36.385 2.6648-45.641 0.99387zm-90-306.96c0-0.20765 0.7875-0.99515 1.75-1.75 1.5861-1.2439 1.6214-1.2085 0.37756 0.37756-1.3064 1.6658-2.1276 2.1955-2.1276 1.3724zm9.5-8.6224c0.99549-1.1 2.035-2 2.31-2s-0.31449 0.9-1.31 2-2.035 2-2.31 2 0.31449-0.9 1.31-2zm21-23c0.99549-1.1 2.035-2 2.31-2s-0.31449 0.9-1.31 2-2.035 2-2.31 2 0.31449-0.9 1.31-2zm100.66-162c0-1.375 0.22698-1.9375 0.50439-1.25s0.27741 1.8125 0 2.5-0.50439 0.125-0.50439-1.25zm33.921-167.58c0.048-1.165 0.28494-1.4019 0.60416-0.60417 0.28887 0.72187 0.25335 1.5844-0.0789 1.9167-0.33229 0.33229-0.56864-0.25834-0.52522-1.3125z"/><path class="bagb-sq__fur" d="m239.25 904.31c0.9625-0.25152 2.5375-0.25152 3.5 0 0.9625 0.25153 0.175 0.45733-1.75 0.45733s-2.7125-0.2058-1.75-0.45733zm32.5 0.0271c0.6875-0.27741 1.8125-0.27741 2.5 0s0.125 0.50439-1.25 0.50439-1.9375-0.22698-1.25-0.50439zm-41.938-1.0208c0.72187-0.28887 1.5844-0.25335 1.9167 0.0789 0.33229 0.33229-0.25834 0.56864-1.3125 0.52522-1.165-0.048-1.4019-0.28494-0.60417-0.60416zm53 0c0.72187-0.28887 1.5844-0.25335 1.9167 0.0789 0.33229 0.33229-0.25834 0.56864-1.3125 0.52522-1.165-0.048-1.4019-0.28494-0.60417-0.60416zm-60-1c0.72187-0.28887 1.5844-0.25335 1.9167 0.0789 0.33229 0.33229-0.25834 0.56864-1.3125 0.52522-1.165-0.048-1.4019-0.28494-0.60417-0.60416zm184.69-61.317c2.7086-2.75 5.1498-5 5.4248-5s-1.7162 2.25-4.4248 5-5.1498 5-5.4248 5 1.7162-2.25 4.4248-5zm-309.63 0.25c-1.2439-1.5861-1.2085-1.6214 0.37756-0.37756 1.6657 1.3064 2.1955 2.1276 1.3724 2.1276-0.20766 0-0.99516-0.7875-1.75-1.75zm318.13-8.5629c0-0.1721 1.4625-1.6346 3.25-3.25l3.25-2.9371-2.9371 3.25c-2.7378 3.0295-3.5629 3.7096-3.5629 2.9371zm-332.13-5.4371c-1.2439-1.5861-1.2085-1.6214 0.37756-0.37756 1.6657 1.3064 2.1955 2.1276 1.3724 2.1276-0.20766 0-0.99516-0.7875-1.75-1.75zm344.13-7.6276c0-0.20765 0.7875-0.99515 1.75-1.75 1.5861-1.2439 1.6214-1.2085 0.37756 0.37756-1.3064 1.6658-2.1276 2.1955-2.1276 1.3724zm-158.25-13.346c1.7875-0.22182 4.7125-0.22182 6.5 0 1.7875 0.22183 0.325 0.40333-3.25 0.40333s-5.0375-0.1815-3.25-0.40333zm169.25 0.34584c0-0.20765 0.7875-0.99515 1.75-1.75 1.5861-1.2439 1.6214-1.2085 0.37756 0.37756-1.3064 1.6658-2.1276 2.1955-2.1276 1.3724zm-182.25-1.2847c0.6875-0.27741 1.8125-0.27741 2.5 0s0.125 0.50439-1.25 0.50439-1.9375-0.22698-1.25-0.50439zm29.012-0.045c1.2439-0.23919 3.0439-0.23011 4 0.0202 0.95609 0.25029-0.0617 0.446-2.2617 0.4349-2.2-0.0111-2.9822-0.21589-1.7383-0.45508zm-36.012-0.955c0.6875-0.27741 1.8125-0.27741 2.5 0s0.125 0.50439-1.25 0.50439-1.9375-0.22698-1.25-0.50439zm44 0c0.6875-0.27741 1.8125-0.27741 2.5 0s0.125 0.50439-1.25 0.50439-1.9375-0.22698-1.25-0.50439zm6.0625-1.0208c0.72187-0.28887 1.5844-0.25335 1.9167 0.0789 0.33229 0.33229-0.25834 0.56864-1.3125 0.52522-1.165-0.048-1.4019-0.28494-0.60417-0.60416zm-58-1c0.72187-0.28887 1.5844-0.25335 1.9167 0.0789 0.33229 0.33229-0.25834 0.56864-1.3125 0.52522-1.165-0.048-1.4019-0.28494-0.60417-0.60416zm66-1c0.72187-0.28887 1.5844-0.25335 1.9167 0.0789 0.33229 0.33229-0.25834 0.56864-1.3125 0.52522-1.165-0.048-1.4019-0.28494-0.60417-0.60416zm-73.812-1.3169c-0.825-0.53316-1.05-0.96937-0.5-0.96937s1.675 0.43621 2.5 0.96937 1.05 0.96937 0.5 0.96937-1.675-0.43621-2.5-0.96937zm-8.25-3.572c-3.8772-2.1034-3.4381-2.8293 0.5-0.82653 3.7695 1.9171 4.4366 2.4139 3.1667 2.3585-0.50417-0.022-2.1542-0.71139-3.6667-1.5319zm103.25-2.8767c0-0.275 1.35-1.1981 3-2.0514s3-1.3264 3-1.0514-1.35 1.1981-3 2.0514-3 1.3264-3 1.0514zm-114.89-5.1388c-2.8063-2.5231-6.0523-6.0106-7.2134-7.75-1.4534-2.1772-0.9737-1.8525 1.5394 1.0421 2.0078 2.3126 5.5427 5.7913 7.8553 7.7304 2.3126 1.9392 3.9159 3.5345 3.5628 3.5453-0.35301 0.0108-2.9379-2.0448-5.7441-4.5678zm127.89-2.7902c0-0.20765 0.7875-0.99515 1.75-1.75 1.5861-1.2439 1.6214-1.2085 0.37756 0.37756-1.3064 1.6658-2.1276 2.1955-2.1276 1.3724zm7.2167-6.1354c2.0442-2.1379 3.8788-3.6846 4.0769-3.4371s-1.4744 1.9967-3.7167 3.8871l-4.0769 3.4371zm-182.47-2.1928c1.2375-0.23836 3.2625-0.23836 4.5 0 1.2375 0.23835 0.225 0.43337-2.25 0.43337s-3.4875-0.19502-2.25-0.43337zm11.012-2e-3c1.2439-0.23919 3.0439-0.23011 4 0.0202 0.95609 0.25029-0.0617 0.446-2.2617 0.4349-2.2-0.0111-2.9822-0.21589-1.7383-0.45508zm-15.949-0.97585c0.72187-0.28887 1.5844-0.25335 1.9167 0.0789 0.33229 0.33229-0.25834 0.56864-1.3125 0.52522-1.165-0.048-1.4019-0.28494-0.60417-0.60416zm24 0c0.72187-0.28887 1.5844-0.25335 1.9167 0.0789 0.33229 0.33229-0.25834 0.56864-1.3125 0.52522-1.165-0.048-1.4019-0.28494-0.60417-0.60416zm4.6875-1.3164c1.1-0.47269 2.675-0.85943 3.5-0.85943 0.94548 0 0.76064 0.31771-0.5 0.85943-1.1 0.47269-2.675 0.85943-3.5 0.85943-0.94548 0-0.76064-0.31771 0.5-0.85943zm-133.42-4.5833c0.04798-1.165 0.28494-1.4019 0.60417-0.60417 0.28887 0.72187 0.25334 1.5844-0.07895 1.9167-0.33229 0.33229-0.56864-0.25834-0.52522-1.3125zm90.374-2.6667-3.953-4.25 4.25 3.953c2.3375 2.1741 4.25 4.0866 4.25 4.25 0 0.75658-0.87085-4.9e-4 -4.547-3.953zm214.51-1c4.144-4.4152 5.0418-5.2091 5.0418-4.4582 0 0.16049-2.1375 2.298-4.75 4.75l-4.75 4.4582zm-221.54-8.2952c-1.465-2.4998-2.4951-4.7137-2.2892-4.9196s1.6105 1.8394 3.1212 4.5452c3.455 6.1882 2.7587 6.5016-0.83202 0.37447zm228.58 0.04517c1.2918-1.375 2.5736-2.5 2.8486-2.5s-0.55688 1.125-1.8486 2.5-2.5736 2.5-2.8486 2.5 0.55688-1.125 1.8486-2.5zm3-3.8129c0-0.1721 1.4625-1.6346 3.25-3.25l3.25-2.9371-2.9371 3.25c-2.7378 3.0295-3.5629 3.7096-3.5629 2.9371zm-236-3.6871c-0.90129-0.58246-1.0246-0.97549-0.30902-0.98469 0.65504-8e-3 1.4691 0.43469 1.809 0.98469 0.7673 1.2415 0.42112 1.2415-1.5 0zm-81.921-1.5833c0.04798-1.165 0.28494-1.4019 0.60417-0.60417 0.28887 0.72187 0.25334 1.5844-0.07895 1.9167-0.33229 0.33229-0.56864-0.25834-0.52522-1.3125zm75.734-0.0998c0.72187-0.28887 1.5844-0.25335 1.9167 0.0789 0.33229 0.33229-0.25834 0.56864-1.3125 0.52522-1.165-0.048-1.4019-0.28494-0.60417-0.60416zm251.69-5.3169c2.1482-2.2 4.1309-4 4.4059-4s-1.2577 1.8-3.4059 4-4.1309 4-4.4059 4 1.2577-1.8 3.4059-4zm-263.06 1.4448c-1.8303-1.4664-1.7984-1.4872 0.55887-0.36454 3.061 1.4578 3.6283 1.9197 2.3578 1.9197-0.53655 0-1.849-0.69982-2.9167-1.5552zm-6.495-5.1948-3.4462-3.75 3.75 3.4462c2.0625 1.8954 3.75 3.5829 3.75 3.75 0 0.76362-0.84622 0.0442-4.0538-3.4462zm276.55-2.25c0.99549-1.1 2.035-2 2.31-2s-0.31449 0.9-1.31 2-2.035 2-2.31 2 0.31449-0.9 1.31-2zm-284.05-8.0929c-0.87968-1.7011-1.4219-3.2705-1.2049-3.4874s1.1429 1.1748 2.0576 3.0929c2.0566 4.3127 1.344 4.6424-0.85266 0.39451zm292.55 2.6217c0-0.275 2.7-1.863 6-3.5288s6-2.8038 6-2.5288-2.7 1.863-6 3.5288-6 2.8038-6 2.5288zm15.5-8.2313c0.55-0.5674 3.25-2.2905 6-3.8291 2.75-1.5386 4.55-2.3333 4-1.7659-0.55 0.5674-3.25 2.2905-6 3.8291-2.75 1.5386-4.55 2.3333-4 1.7659zm-362.42-1.8808c0.04798-1.165 0.28494-1.4019 0.60417-0.60417 0.28887 0.72187 0.25334 1.5844-0.07895 1.9167-0.33229 0.33229-0.56864-0.25834-0.52522-1.3125zm47.19 0.89034c0.97297-0.25354 2.323-0.23687 3 0.0371 0.67703 0.27393-0.11903 0.48137-1.769 0.46099-1.65-0.0204-2.2039-0.2445-1.231-0.49804zm-7.769-2.1676c-1.65-1.0192-3.893-2.93-4.9844-4.2463-1.7932-2.1626-1.6969-2.1397 1 0.23801 1.6414 1.4472 4.3344 3.3416 5.9844 4.21 1.65 0.86833 2.55 1.5951 2 1.6151-0.55 0.02-2.35-0.79758-4-1.8168zm-9.0481-10.232c-0.87968-1.7011-1.4219-3.2705-1.2049-3.4874 0.21698-0.21698 1.1429 1.1748 2.0576 3.0929 2.0566 4.3127 1.344 4.6424-0.85265 0.39451zm352.55 0.71537c0-0.20765 0.7875-0.99515 1.75-1.75 1.5861-1.2439 1.6214-1.2085 0.37756 0.37756-1.3064 1.6658-2.1276 2.1955-2.1276 1.3724zm-382.84-2.6224c0-1.375 0.22697-1.9375 0.50439-1.25 0.27741 0.6875 0.27741 1.8125 0 2.5-0.27741 0.6875-0.50439 0.125-0.50439-1.25zm393.84-7.5c3.5432-3.575 6.6672-6.5 6.9422-6.5s-2.399 2.925-5.9422 6.5-6.6672 6.5-6.9422 6.5 2.399-2.925 5.9422-6.5zm-366.84-0.5c0-1.375 0.22697-1.9375 0.50439-1.25 0.27741 0.6875 0.27741 1.8125 0 2.5-0.27741 0.6875-0.50439 0.125-0.50439-1.25zm-5.7049-11.25-3.9529-4.25 4.25 3.953c3.9525 3.6762 4.7095 4.547 3.9529 4.547-0.16338 0-2.0759-1.9125-4.25-4.25zm381.55 1.25c1.1749-1.65 2.3612-3 2.6362-3s-0.46129 1.35-1.6362 3-2.3612 3-2.6362 3 0.46129-1.35 1.6362-3zm-387.13-7.75c-1.2439-1.5861-1.2085-1.6214 0.37756-0.37756 1.6657 1.3064 2.1955 2.1276 1.3724 2.1276-0.20766 0-0.99516-0.7875-1.75-1.75zm392.13-0.25c0.5887-1.1 1.2954-2 1.5704-2s0.0183 0.9-0.57037 2c-0.5887 1.1-1.2954 2-1.5704 2s-0.0183-0.9 0.57037-2zm-394.51-3.0163c-0.34546-0.55897-1.1166-0.71444-1.7135-0.34549-0.64783 0.40038-0.79775 0.20538-0.37188-0.48369 0.98543-1.5945 2.2703-1.4444 2.9571 0.34549 0.65276 1.7011 0.07783 2.0201-0.87171 0.48369zm399.51-5.9837c1.1224-2.2 2.2656-4 2.5406-4s-0.41829 1.8-1.5406 4-2.2656 4-2.5406 4 0.41829-1.8 1.5406-4zm7-13c1.1224-2.2 2.2656-4 2.5406-4s-0.41829 1.8-1.5406 4-2.2656 4-2.5406 4 0.41829-1.8 1.5406-4zm5-9c0.5887-1.1 1.2954-2 1.5704-2s0.0183 0.9-0.57037 2c-0.5887 1.1-1.2954 2-1.5704 2s-0.0183-0.9 0.57037-2zm83-6.5c1.2918-1.375 2.5736-2.5 2.8486-2.5s-0.55688 1.125-1.8486 2.5-2.5736 2.5-2.8486 2.5 0.55688-1.125 1.8486-2.5zm-79-0.5c0.5887-1.1 1.2954-2 1.5704-2s0.0183 0.9-0.57037 2c-0.5887 1.1-1.2954 2-1.5704 2s-0.0183-0.9 0.57037-2zm3.5-6c0.85325-1.65 1.7764-3 2.0514-3s-0.19811 1.35-1.0514 3-1.7764 3-2.0514 3 0.19811-1.35 1.0514-3zm3.5-6c0.5887-1.1 1.2954-2 1.5704-2s0.0183 0.9-0.57037 2c-0.5887 1.1-1.2954 2-1.5704 2s-0.0183-0.9 0.57037-2zm4-7c0.5887-1.1 1.2954-2 1.5704-2s0.0183 0.9-0.57037 2c-0.5887 1.1-1.2954 2-1.5704 2s-0.0183-0.9 0.57037-2zm-41.026-1.049c-0.75827-1.4168-0.78864-3.0365-0.0985-5.25 1.936-6.2088 2.9086-16.208 2.0831-21.415-0.50117-3.1614-2.4273-7.9086-4.8925-12.058-2.2362-3.7642-4.0659-7.3803-4.0659-8.0358 0-4.1694-5.0409 5.1431-5.5799 10.308-0.0574 0.55-0.99649 3.025-2.0869 5.5-1.0904 2.475-3.0094 7.7362-4.2645 11.691-2.6513 8.3554-5.1232 11.338-7.655 9.2369-1.9021-1.5786-1.5906-8.0572 0.93395-19.428 0.85477-3.85 2.482-13.382 3.616-21.182 2.236-15.38 5.4457-27.69 10.028-38.457 2.5995-6.1087 2.7266-6.8604 1.1597-6.8604-2.5604 0-10.157 5.0853-13.786 9.2287-2.1864 2.4961-4.4281 7.467-7.4074 16.425-2.3497 7.0653-6.7883 18.021-9.8636 24.346-6.9446 14.283-6.5981 13.43-5.0691 12.485 0.86695-0.53581 1.039-0.39695 0.52959 0.42733-0.41505 0.67157-0.94561 1.0301-1.179 0.79667-0.2334-0.23341-2.2018 1.353-4.3741 3.5254-4.2204 4.2204-5.9144 4.4356-7.4884 0.95124-0.54292-1.2019-1.2556-2.1853-1.5838-2.1853s-2.2687 2.4277-4.3122 5.3949c-4.9018 7.1172-14.925 16.605-17.543 16.605-2.5044 0-2.6345-1.8205-0.61091-8.5444 0.80483-2.6742 1.253-5.0725 0.99605-5.3295-0.25699-0.257-1.507 0.5095-2.7778 1.7033-3.0549 2.8699-5.6837 2.8332-5.6746-0.0794 9e-3 -2.945 3.5327-17.595 5.1303-21.331 0.68648-1.6053 3.2989-5.8437 5.8054-9.4187 5.7124-8.1475 6.255-6.4765 2.6632 8.2009-1.3862 5.6645-2.8266 12.324-3.201 14.799l-0.6806 4.5 2.1246-2.6409c3.8671-4.8069 8.9721-16.86 10.021-23.661 0.56824-3.6842 1.4489-10.398 1.957-14.92 1.5138-13.471 7.1941-23.607 22.251-39.703 3.3832-3.6166 5.8054-6.5757 5.3827-6.5757-1.437 0-12.943 6.8085-17.172 10.161-5.8351 4.6259-8.863 9.0506-11.39 16.644-1.7298 5.198-3.5434 7.9887-9.0546 13.932-6.7097 7.2364-8.5037 10.315-18.219 31.262-6.17 13.303-9.3568 16.901-18.269 20.625-7.0994 2.9663-7.8684-1.5491-2.2172-13.02 1.5974-3.2425 2.6823-6.1174 2.411-6.3888-0.27134-0.27135 0.65091-1.8532 2.0495-3.5153 4.6887-5.5723 11.124-20.058 16.778-37.77 5.7745-18.087 7.3601-21.109 17.014-32.422 6.4971-7.6135 1.9211-7.0572-7.0731 0.8599-5.101 4.4901-8.9042 11.51-13.412 24.758-6.6022 19.402-12.659 31.526-25.038 50.123-3.2035 4.8125-5.4968 8.7676-5.0963 8.7891 2.1051 0.11315-6.4418 2.9609-8.8866 2.9609-3.661 0-4.0191-2.6152-1.4037-10.25 1.4844-4.3331 1.2338-4.4292-4.6223-1.772-4.5242 2.0529-16.859 2.8696-16.859 1.1162 0-0.49816 2.9312-2.2774 6.5137-3.9539 3.5825-1.6765 6.7807-3.7439 7.107-4.5942 0.32632-0.85038 1.3327-1.5505 2.2363-1.5558 2.7587-0.0161 15.066-9.9508 20.523-16.566 5.6745-6.8795 10.279-14.425 8.8029-14.425-1.6132 0-18.312 15.3-25.903 23.734-3.992 4.4349-8.24 8.2056-9.5 8.4328-7.4493 1.3426-7.6435-2.971-0.71095-15.793 3.2432-5.9983 4.5936-9.3966 3.75-9.4372-0.72504-0.0349-0.32088-0.46476 0.89814-0.95534 2.3977-0.96493 7.6616-10.735 13.362-24.801 2.2125-5.4593 5.4793-10.96 9.5027-16 6.2683-7.8526 10.124-14.181 8.6403-14.181-1.8613 0-9.9793 5.9589-13.743 10.088-2.212 2.4266-6.2085 8.237-8.8812 12.912-9.2091 16.108-14.938 25.518-19.428 31.913-2.4765 3.527-4.5027 6.9947-4.5027 7.706s-0.375 1.0615-0.83334 0.77822c-0.45833-0.28326-0.83333-0.07359-0.83333 0.46594 0 0.53954-2.7719 2.3661-6.1597 4.059-6.1119 3.0541-11.19 3.939-12.3 2.1433-0.51712-0.83672 3.1425-9.8199 4.5079-11.065 1.0533-0.96073 4.9518-6.8141 4.9518-7.4348 0-0.34436-3.2625 1.5658-7.25 4.2447-9.729 6.5363-16.75 7.8111-16.75 3.0415 0-1.0641 1.35-4.8222 3-8.3513s3-7.1854 3-8.125c0-0.9396 0.29761-1.4108 0.66135-1.047 1.6842 1.6842 9.5418-14.903 14.841-31.328 2.0693-6.4143 6.0626-14.747 8.2668-17.25 0.89096-1.0118 1.0755-1.75 0.43747-1.75-0.60693 0-5.2392 3.9356-10.294 8.7458-6.9841 6.6463-9.9161 10.265-12.214 15.075-1.7214 3.6038-6.0272 9.6346-9.9986 14.004-9.0966 10.009-9.0954 10.007-12.239 21.675-1.482 5.5-3.5751 11.735-4.6514 13.855-1.2502 2.4624-1.4789 3.5669-0.63326 3.058 0.97528-0.58686 0.94803-0.33382-0.10351 0.9614-3.5122 4.3261-14.422 6.4852-15.717 3.1104-0.97449-2.5395 4.3296-18.175 10.474-30.874 0.23662-0.48905-0.19067-0.53537-0.94952-0.10293-0.75885 0.43245-0.39646-0.17021 0.80531-1.3392 1.2018-1.169 5.3358-6.7477 9.1867-12.397 3.8509-5.6494 10.873-14.547 15.604-19.772 12.132-13.398 16.958-21 13.331-21-2.0594 0-11.062 10.076-18.763 21-17.828 25.289-21.099 29.693-24.471 32.946-1.9649 1.8954-3.5743 3.9204-3.5764 4.5-5e-3 1.3258-7.7226 4.5538-10.888 4.5538-2.1695 0-2.3201-0.30959-1.7774-3.654 0.32614-2.0097 2.185-7.0064 4.1308-11.104 3.9114-8.2364 4.0484-8.6757 2.3834-7.6467-0.72104 0.44563-0.88282 0.27393-0.4309-0.45729 0.39798-0.64395 1.1034-0.93612 1.5675-0.64926 0.46415 0.28687 4.5287-6.7781 9.0322-15.7 4.7147-9.34 7.7219-16.377 7.0888-16.588-1.9671-0.6557-7.5207 3.5522-11.193 8.4809-1.9745 2.6499-7.536 11.392-12.359 19.426-4.8229 8.0345-11.179 17.313-14.124 20.62s-5.0969 6.2694-4.7817 6.5847c0.31525 0.31525-0.71357 0.23113-2.2863-0.18693-1.9227-0.5111-2.9688-1.5109-3.1933-3.0519-0.41578-2.8542 4.2199-17.927 7.5111-24.423 1.3514-2.6672 2.1978-5.1088 1.8808-5.4258s0.242-1.5098 1.2422-2.6506c2.0784-2.3704 12.617-24.49 11.975-25.133-0.23284-0.23284-3.8374 4.6351-8.01 10.818-4.1727 6.1825-10.524 14.681-14.115 18.885-3.5906 4.2043-6.2181 7.9889-5.839 8.4103 0.37906 0.42142 0.16514 0.46626-0.47538 0.0996-0.64052-0.3666-1.3191-0.20314-1.5079 0.36326-0.1888 0.56639-2.0272 1.3031-4.0854 1.6371-3.5403 0.57456-3.7421 0.46328-3.7421-2.0634 0-2.7564 2.8082-9.0287 6.1938-13.834 1.063-1.5087 1.6526-3.1962 1.3104-3.75-0.34224-0.55375-0.172-1.0068 0.37832-1.0068 0.87254 0 8.3335-9.0774 10.562-12.85 0.65932-1.1163 0.38717-1.1336-1.5735-0.10001-12.095 6.3763-23.152 15.598-26.41 22.028-2.92 5.7623-3.0488 6.6289-0.7125 4.7947 0.96147-0.75484-0.65806 1.4401-3.5989 4.8776-5.7067 6.6703-9.1492 8.1102-9.1492 3.8267 0-1.3328 1.0451-3.6953 2.3224-5.25 1.2773-1.5547 4.4651-7.1813 7.084-12.504 4.138-8.4097 5.7-10.487 11.928-15.861 3.9413-3.401 10.316-9.6989 14.166-13.995s10.876-12.009 15.613-17.139c5.324-5.7655 9.1346-10.855 9.9782-13.328 1.5774-4.6233 12.294-15.611 21.045-21.577 4.3928-2.9951 6.4534-5.3408 9.34-10.633 2.5216-4.6228 7.6962-10.939 16.212-19.79 21.195-22.028 22.311-23.252 22.311-24.466 0-0.64807 1.0764-3.0584 2.392-5.3564 1.3156-2.2979 2.6763-6.2031 3.0238-8.6781 0.77522-5.5213 5.0531-19.787 10.398-34.672 3.6741-10.233 4.1031-12.502 5.1041-27 1.3478-19.519 3.3207-31.244 7.1423-42.447 2.1994-6.4473 2.9435-10.478 2.9533-16 0.0195-10.942 3.1175-24.026 8.9918-37.974 6.3982-15.192 8.5573-21.745 11.048-33.531 1.6801-7.9498 3.912-30.651 3.938-40.055 0.01509-5.4629 1.8575-6.3214 13.566-6.3214h10.414l1.1414-4.5328c0.62775-2.493 1.8818-4.929 2.7868-5.4134 2.4459-1.309 8.544 0.15128 28.997 6.9437 22.475 7.4641 30.833 9.4842 47.604 11.506 7.15 0.86188 16.46 2.2116 20.689 2.9993 4.2289 0.78777 22.004 3.2548 39.5 5.4824 33.007 4.2024 49.468 7.0703 51.83 9.0303 0.75699 0.62824 2.1154 3.0774 3.0186 5.4425 0.90325 2.3651 2.6144 4.7907 3.8026 5.3901 1.1882 0.59945 6.3679 1.5362 11.51 2.0817s10.016 1.5442 10.829 2.2194c2.033 1.6872 1.4613 8.228-2.6645 30.485l-3.3615 18.134 5.8482 9.8659c3.2165 5.4263 7.8192 13.578 10.228 18.116 3.9326 7.4075 4.6737 8.25 7.2576 8.25 1.9402 0 3.0726-0.61365 3.4756-1.8834 1.024-3.2264-1.3972-11.337-5.4082-18.117-2.115-3.575-4.3684-8.1598-5.0074-10.188-0.63899-2.0286-2.9361-5.5166-5.1046-7.7512-4.7196-4.8632-4.722-4.8978-1.9816-28.06 1.0737-9.075 2.2629-21.338 2.6428-27.25l0.69058-10.75h3.1746c3.8287 0 12.256 2.7469 13.222 4.3096 0.38153 0.61734 0.94648 2.6776 1.2554 4.5783 0.53442 3.2878 0.84909 3.5211 6.4721 4.7982 6.9508 1.5786 8.9082 2.9374 8.2879 5.7531-3.6615 16.619-10.189 43.046-11.822 47.864-2.9093 8.5811-2.0573 16.343 3.6874 33.592 5.7218 17.181 6.3608 23.63 3.5192 35.517l-2.1307 8.9126 3.4845 8.1129c5.2327 12.183 6.2071 19.682 4.7153 36.285-1.3433 14.95-4.1346 29.393-6.6034 34.167-0.85616 1.6556-1.5566 4.2088-1.5566 5.6737 0 1.4649-0.8718 4.2998-1.9373 6.2997-2.7276 5.1194-7.7537 48.233-6.6026 56.636 0.41399 3.0223 0.31835 3.4715-0.39131 1.8379-0.97016-2.2332-4.7045-4.036-5.8941-2.8453-0.37105 0.3714-0.69094 5.538-0.71087 11.481-0.0415 12.38-0.93922 14.471-5.9082 13.765-1.6806-0.23888-3.7611-0.74458-4.6234-1.1238-1.2936-0.56889-2.0525 1.2762-4.3397 10.551-3.2617 13.227-6.775 23.061-8.4364 23.615-1.5607 0.52024-3.8715-5.1556-4.7282-11.613-0.40266-3.0354-1.1906-5.1678-1.9094-5.1678-0.8454 0-1.4366 3.2905-1.9118 10.64-0.84917 13.135-2.196 19.656-4.6667 22.598-3.0129 3.5875-3.9073 0.75476-3.9246-12.429-9e-3 -6.8582-0.43735-11.952-1.0363-12.322-2.3445-1.449-4.0617 6.8329-4.9421 23.835-1.1675 22.546-3.2372 30.86-6.5532 26.325-0.66711-0.91233-1.7853-4.3561-2.4849-7.6528-0.83075-3.9147-1.7647-5.994-2.6923-5.994-0.80012 0-2.9511 3.3592-4.9263 7.6935-10.306 22.615-11.117 23.629-14.996 18.764-1.2627-1.5836-2.5391-2.636-2.8364-2.3388-0.29729 0.29728-2.4747 4.7797-4.8387 9.9609-5.84 12.8-8.5869 17.92-9.613 17.92-1.4965 0-1.9535-3.8493-1.3712-11.549 0.41043-5.4268 0.23877-7.451-0.63185-7.451-1.4408 0-4.0933 6.0119-4.0933 9.2775 0 4.4679-4.2407 19.261-7.6602 26.723-4.9411 10.781-11.484 16.812-13.935 12.845-0.41472-0.67103-0.27696-0.88469 0.32898-0.5102 1.556 0.96169 2.208-3.984 2.914-22.108 0.5746-14.749 0.4822-16.214-0.98654-15.651-1.9737 0.75739-5.4566 6.2238-6.6773 10.48-0.55794 1.9454-0.50045 5.0773 0.15207 8.2855 2.7795 13.666-1.3835 32.349-8.7237 39.152-3.2824 3.0421-4.99 3.1633-6.4383 0.45715zm44.341-102.18c0.3212-1.8008 1.2385-6.5834 2.0383-10.628 0.79988-4.0444 1.0769-6.9694 0.61559-6.5-1.2165 1.238-4.9684 15.316-4.9684 18.642 0 3.701 1.5671 2.6754 2.3144-1.5146zm-191.69-7.5243c6.5011-12.037 9.3932-16.116 16.643-23.473 3.4381-3.4892 8.4977-8.7757 11.244-11.748l4.9925-5.4037-6 4.3124c-3.3 2.3718-9.6045 6.664-14.01 9.5383-9.3367 6.0915-11.819 9.8352-15.904 23.981-4.1831 14.487-3.5806 15.042 3.035 2.7932zm160.59-17.474c11.848-9.5346 13.822-12.07 17.342-22.276 1.5173-4.4 3.0912-8.3809 3.4974-8.8464 0.98474-1.1284 2.9458 8.2553 2.9458 14.096 0 3.0115 0.34264 4.3081 0.97209 3.6787 2.8719-2.8719 3.9996-52.856 1.2545-55.601-1.4256-1.4256-1.8755-0.30187-7.8768 19.673-7.8584 26.157-13.175 35.472-32.026 56.116-4.5783 5.0137-8.3242 9.4275-8.3242 9.8084 0 0.78628 7.9974-5.207 22.215-16.648zm-103.98 2.5376c4.7259-3.4568 8.7632-7.81 8.7632-9.4487 0-2.5226-7.7326 0.7376-14.5 6.1135-3.76 2.9869-9.5 10.326-9.5 12.146 0 0.99831 8.7211-4.0447 15.237-8.8107zm80.829-9.9496c9.6258-16.801 15.403-31.338 13.035-32.802-0.45848-0.28335-1.5464 0.27249-2.4177 1.2352-3.2768 3.6208-15.46 31.193-20.194 45.702l-0.65257 2 1.6381-2c0.90094-1.1 4.767-7.4611 8.5912-14.136zm-188.06-16.864c4.525-6.05 11.662-14.801 15.86-19.448 8.2291-9.1069 8.0049-9.371-1.5632-1.8417-6.878 5.4124-14.327 13.313-17.959 19.048-2.9196 4.6099-6.7251 14.049-5.4759 13.582 0.50084-0.18719 4.6128-5.2903 9.1378-11.34zm182.59-16c2.5857-11.118 2.8403-14.132 3.4637-41 0.52322-22.551 1.1448-31.78 2.7953-41.5 2.8792-16.957 2.6844-35.775-0.3792-36.62-0.53483-0.14761-3.6428 3.5654-6.9066 8.2512s-9.2958 12.648-13.404 17.694c-8.2022 10.074-11.18 15.702-13.733 25.961-2.9506 11.853-1.005 10.653 9.9411-6.1308 7.4568-11.434 18.689-25.155 20.592-25.155 1.3251 0-0.0227 10.163-3.2231 24.304-3.102 13.706-3.1156 13.89-1.9227 26 1.7629 17.896 1.5563 27.324-1.2755 58.196-0.68944 7.5164 0.87932 3.6458 4.053-10zm-23.575-0.86774c1.7362-6.5272 4.7145-14.852 6.6185-18.5 5.1309-9.8298 7.1843-26.239 3.1137-24.882-1.1377 0.37924-11.997 23.303-13.79 29.11-1.267 4.1036-2.3567 21.921-1.5397 25.176 1.0553 4.2045 2.1419 2.0877 5.5976-10.904zm-100.46-2.0497c4.9836-5.1086 9.288-10.618 10.95-14.015 2.8811-5.8888 4.5073-14.568 2.7296-14.568-1.7766 0-11.935 10.661-16.342 17.15-6.2832 9.2524-9.873 19.85-6.7238 19.85 0.64598 0 4.8697-3.7878 9.386-8.4174zm36.366 2.3554c4.6316-3.3551 7.9525-9.4586 6.1353-11.276-1.2239-1.2239-9.3949 6.2454-12.403 11.338-1.7154 2.9039-1.711 2.9999 0.13442 2.9999 1.0486 0 3.8086-1.3779 6.1335-3.062zm-84.914-13.615c13.526-9.0651 23.22-18.006 26.593-24.528 2.1223-4.104 6.6771-17.888 5.0956-15.42-9.381 14.637-17.475 23.655-26.034 29.008-7.276 4.5504-15.836 14.617-12.43 14.617 0.70896 0 3.758-1.6547 6.7757-3.677zm251.37-32c2.0298-21.619 2.0434-22.925 0.22231-21.414-0.76472 0.63466-2.4522 3.5023-3.75 6.3724-2.2064 4.8796-2.3596 6.4198-2.3596 23.719 0 31.017 2.5075 27.321 5.8873-8.6769zm-112.13 16.079c1.8944-5.291 2.3576-13.402 0.76537-13.402-1.9694 0-10.065 19.721-9.9793 24.31 0.036 1.9242 0.49183 1.6922 3.75-1.908 2.04-2.2541 4.4987-6.3041 5.4639-9zm135.61-21.549c12.643-33.069 13.597-37.23 13.506-58.853-0.0677-15.986-1.6699-37.636-2.8743-38.84-1.1047-1.1047-1.9703 1.4948-5.1896 15.587-1.8538 8.1145-4.7055 17.617-6.337 21.116-2.9176 6.2574-3.7453 10.138-2.1626 10.138 0.44211 0 2.3134-1.5575 4.1585-3.4611 7.3635-7.5972 6.4719 0.33305-1.983 17.639-4.1301 8.4536-6.9315 15.949-8.9227 23.874-4.0846 16.256-6.3289 38.469-4.3957 43.507 0.98322 2.5622 3.8619-3.6622 14.201-30.706zm-237.56 19.897c15.507-11.429 31.097-35.252 39.04-59.659 1.9739-6.0649 4.543-12.897 5.7091-15.183 1.1661-2.2858 3.6355-8.7127 5.4876-14.282 3.2418-9.7483 3.3692-9.9538 3.4164-5.507 0.1187 11.171-6.5823 36.193-15.072 56.279-1.6036 3.794-2.7421 7.0717-2.53 7.2838 0.36342 0.36341 6.4682-8.7664 11.258-16.837 2.925-4.9281 4.8428-11.073 7.9104-25.345 4.2523-19.784 4.7108-25.699 2.9923-38.607-2.6151-19.642-3.6275-29.741-4.3894-43.786-0.64855-11.956-0.88517-13.259-1.9496-10.738-1.9849 4.7005-3.1344 19.842-3.1603 41.631-0.0302 25.365-1.3827 34.836-7.5849 53.116-4.2006 12.38-5.2003 14.399-8.2862 16.731-11.826 8.9378-20.895 19.433-28.648 33.152-9.7332 17.223-11.071 19.353-15.007 23.88-7.5041 8.6334-7.5145 8.6732-1.4698 5.6362 3.017-1.5158 8.5444-5.0106 12.283-7.7661zm42.102-3.6391c12.036-20.082 16.142-30.111 12.326-30.111-1.4752 0-8.7196 9.0929-13.968 17.532-5.6079 9.0174-10.434 27.934-6.238 24.452 0.83595-0.69378 4.3818-6.0364 7.8798-11.872zm139.02-14.895c1.4482-4.7939 3.5629-11.866 4.6992-15.716 2.1774-7.3772 6.374-14.932 7.8038-14.048 0.46575 0.28785 1.1494 2.6664 1.5192 5.2857 1.3623 9.649 2.0422 10.152 5.882 4.3495 6.5847-9.9501 11.051-26.596 12.697-47.326 1.4469-18.217 0.47881-19.749-4.4563-7.0548-4.2158 10.844-10.239 22.63-16.549 32.386-6.9441 10.734-9.8208 17.944-13.495 33.821-1.9361 8.3663-3.5202 16.139-3.5202 17.272 0 4.3332 2.8017-0.30327 5.4194-8.9683zm78.011-4.6778c6.5745-9.9049 8.7476-15.053 9.5914-22.724 0.4425-4.0227 0.67206-7.448 0.51012-7.6118-0.16195-0.16378-1.9939 3.3237-4.071 7.75-4.0715 8.6762-5.7327 10.285-4.4372 4.2978 0.44627-2.0625 2.0113-13.2 3.4779-24.75 1.4666-11.55 3.0048-22.575 3.4182-24.5l0.75163-3.5 1.6641 3.8721c0.91528 2.1297 1.6642 4.1682 1.6642 4.53s2.0174 7.3804 4.483 15.597c3.711 12.366 4.3971 15.891 3.9841 20.47l-0.4989 5.5311 3.0837-6.5c1.696-3.575 3.7272-9.2 4.5138-12.5 1.4925-6.2618 3.1693-27.415 2.0958-26.439-0.33927 0.30854-1.7797 4.5835-3.2009 9.5-1.4212 4.9165-2.9426 9.3028-3.3807 9.7474-2.5867 2.6248-5.7067-12.322-10.606-50.808-1.4703-11.55-2.948-21.448-3.2837-21.994-1.0142-1.6524-2.0008 5.0353-3.6871 24.994-0.88291 10.45-2.2431 26.439-3.0226 35.531-0.77953 9.092-2.9653 25.067-4.8573 35.5-4.8445 26.715-5.1543 29.469-3.3142 29.469 0.82313 0 3.1279-2.4577 5.1218-5.4615zm-265.5-22.038c8.2192-10.941 11.484-16.471 13.922-23.58 2.4486-7.1392 3.6052-14.92 2.2179-14.92-1.7782 0-6.7493 7.6838-13.189 20.387-3.3777 6.6624-9.2321 17.329-13.01 23.703-3.7777 6.3742-6.8686 11.982-6.8686 12.462 0 1.7456 10.333-9.2739 16.927-18.052zm81.624 10.029c5.1739-3.9463 15.469-17.418 19.105-25 4.015-8.3719 4.2239-10.528 1.0201-10.528-3.4751 0-12.514 9.4615-17.273 18.081-3.4126 6.1805-8.4036 17.736-8.4036 19.457 0 1.1801 2.6076 0.23641 5.5515-2.009zm35.499-31.853c2.1938-3.8052 4.6253-9.0013 5.4033-11.547 0.77798-2.5456 3.7852-12.278 6.6827-21.628s5.2376-18.575 5.2002-20.5c-0.0374-1.925-0.98942-5.975-2.1156-9-1.1262-3.025-2.5306-10.356-3.1208-16.291-1.2119-12.186-2.3812-15.551-4.7274-13.603-2.3236 1.9284-4.1435 7.0769-8.9527 25.328-3.3232 12.611-5.1586 17.795-7.1909 20.308-12.529 15.497-22.316 30.504-20.849 31.972 0.3547 0.35469 9.0308-7.6482 19.28-17.784 10.249-10.136 18.821-17.898 19.048-17.248 0.62328 1.7841-8.0728 31.222-13.195 44.666-2.4824 6.5161-4.5135 13.007-4.5135 14.424v2.5769l2.5307-2.3774c1.3919-1.3076 4.3256-5.4907 6.5195-9.2959zm-84.919 4.0747c10.035-10.359 14.709-24.972 13.513-42.25-0.75764-10.951-1.6541-16.5-2.6656-16.5-0.83916 0-2.712 6.9041-8.9282 32.912-2.2889 9.5766-5.2616 20.026-6.6061 23.22-4.103 9.7482-2.8818 10.43 4.6864 2.618zm2.2701-77.25c8.3358-30.244 13.198-44.745 21.628-64.5 14.06-32.949 17.325-41.894 19.472-53.352 1.2878-6.8725 1.3778-9.6837 0.47586-14.863-1.1361-6.5239-2.404-9.691-3.4579-8.6372-0.32467 0.32467-1.0389 4.8116-1.5873 9.971-1.6088 15.137-2.468 18.21-16.566 59.245-14.2 41.332-19.847 59.996-26.368 87.148-7.3693 30.684-4.0389 22.877 6.4038-15.012zm115.72 26.729c1.4403-2.0508 5.4112-8.6786 8.824-14.729 8.1167-14.388 8.4676-14.732 10.759-10.541 3.3335 6.0986 10.941 17.531 12.537 18.839 1.2983 1.0647 1.7345 1.0647 2.4225 0 0.46147-0.71421 0.88453-16.824 0.94013-35.799 0.0901-30.735 0.32671-35.591 2.1686-44.5 3.1225-15.103 3.5529-18.5 2.3439-18.5-1.8182 0-3.6963 4.7742-13.604 34.584-8.2302 24.762-10.627 30.754-16.687 41.714-6.149 11.12-13.822 28.724-13.822 31.711 0 1.9342 1.5353 0.89775 4.1188-2.7807zm-54.136-9.6844c1.8955-4.9855 2.7463-24.262 1.8998-43.044-0.47094-10.45-0.56824-25.032-0.21622-32.404 0.71281-14.928-0.12345-16.298-3.5605-5.8353-7.4553 22.695-8.6161 59.828-2.4693 78.989 1.698 5.2933 2.9539 5.9563 4.3462 2.2942zm111.35-24.575c0.61947-18.364 2.9705-40.898 4.5639-43.745 0.92678-1.6561 2.3462 3.8044 6.7591 26.002 1.5007 7.549 2.9256 13.528 3.1662 13.288 0.2407-0.2407-0.13152-10.88-0.82716-23.642s-0.98519-27.517-0.64344-32.788l0.62136-9.5836-4.5258 5c-4.9935 5.5168-8.1938 11.161-11.057 19.5-1.6108 4.6917-1.8883 8.5128-1.8883 26 0 22.486 1.299 43.73 2.4766 40.5 0.40108-1.1 1.0105-10.339 1.3544-20.531zm-65.942-2.2369c4.1582-11.103 10.569-34.487 12.111-44.177 3.5768-22.469 6.3256-73.061 4.0911-75.296-0.32089-0.32089-1.6207-0.11081-2.8886 0.46684-7.7355 3.5245-27.545 59.628-31.636 89.597-1.2927 9.4705-1.2964 9.6776-0.17473 9.6776 1.2102 0 1.2357-0.0758 9.6287-28.617 4.0624-13.814 8.6359-27.764 10.163-31l2.7773-5.8828 0.3443 6c0.45061 7.8527-1.1848 23.632-4.8193 46.5-3.2318 20.334-4.9503 42.172-3.187 40.5 0.57988-0.55 2.1949-4.0457 3.5889-7.7681zm-66.533-56.735c6.1522-25.491 8.3007-42.159 3.2218-24.996-1.5462 5.225-4.4775 13.733-6.5141 18.906-2.312 5.8728-3.486 10.27-3.1256 11.706 0.92722 3.6943 2.5842 7.6988 3.0096 7.2734 0.21576-0.21575 1.7495-6.0157 3.4083-12.889zm127.64 399c0.85325-1.65 1.7764-3 2.0514-3s-0.19811 1.35-1.0514 3-1.7764 3-2.0514 3 0.19811-1.35 1.0514-3zm-47.305-3.5c0.0204-1.65 0.2445-2.2039 0.49804-1.231s0.23687 2.323-0.0371 3c-0.27393 0.67703-0.48137-0.11903-0.46099-1.769zm50.677-2c0.54004-1.1 1.7147-2.9 2.6103-4l1.6284-2-0.98189 2c-0.54004 1.1-1.7147 2.9-2.6103 4l-1.6284 2zm95.128-2.8776c0-0.20765 0.7875-0.99515 1.75-1.75 1.5861-1.2439 1.6214-1.2085 0.37756 0.37756-1.3064 1.6658-2.1276 2.1955-2.1276 1.3724zm-90-5.6224c0.5887-1.1 1.2954-2 1.5704-2s0.0183 0.9-0.57037 2c-0.5887 1.1-1.2954 2-1.5704 2s-0.0183-0.9 0.57037-2zm-82.69-8.5c6e-3 -3.3 0.1923-4.5294 0.41486-2.7321s0.21797 4.4974-0.0102 6c-0.22818 1.5026-0.41027 0.0321-0.40466-3.2679zm88.669-0.46976c1.1631-1.6334 2.6253-3.2854 3.2495-3.6712 0.62418-0.38576-0.12518 0.95063-1.6652 2.9698-3.3427 4.3825-4.6026 4.9403-1.5843 0.70139zm-182.98-0.4078c0-0.20765 0.7875-0.99515 1.75-1.75 1.5861-1.2439 1.6214-1.2085 0.37756 0.37756-1.3064 1.6658-2.1276 2.1955-2.1276 1.3724zm27-2.1224c1.2918-1.375 2.5736-2.5 2.8486-2.5s-0.55688 1.125-1.8486 2.5-2.5736 2.5-2.8486 2.5 0.55688-1.125 1.8486-2.5zm161.5-4.5c0.99549-1.1 2.035-2 2.31-2s-0.31449 0.9-1.31 2-2.035 2-2.31 2 0.31449-0.9 1.31-2zm-107-1c0.99549-1.1 2.035-2 2.31-2s-0.31449 0.9-1.31 2-2.035 2-2.31 2 0.31449-0.9 1.31-2zm-49.5-0.37756c0-0.20765 0.7875-0.99515 1.75-1.75 1.5861-1.2439 1.6214-1.2085 0.37756 0.37756-1.3064 1.6658-2.1276 2.1955-2.1276 1.3724zm161-4.1224c1.2918-1.375 2.5736-2.5 2.8486-2.5s-0.55688 1.125-1.8486 2.5-2.5736 2.5-2.8486 2.5 0.55688-1.125 1.8486-2.5zm-99.921-0.0833c0.048-1.165 0.28494-1.4019 0.60416-0.60417 0.28887 0.72187 0.25335 1.5844-0.0789 1.9167-0.33229 0.33229-0.56864-0.25834-0.52522-1.3125zm107.92-8.9167c2.9874-3.025 5.6567-5.5 5.9317-5.5s-1.9443 2.475-4.9317 5.5-5.6567 5.5-5.9317 5.5 1.9443-2.475 4.9317-5.5zm9.9582-10.75c4.144-4.4152 5.0418-5.2091 5.0418-4.4582 0 0.16049-2.1375 2.298-4.75 4.75l-4.75 4.4582zm-271.15-2.4331c0.72187-0.28887 1.5844-0.25335 1.9167 0.0789 0.33229 0.33229-0.25834 0.56864-1.3125 0.52522-1.165-0.048-1.4019-0.28494-0.60417-0.60416zm279.19-6.8169c1.8658-1.925 3.6173-3.5 3.8923-3.5s-1.0266 1.575-2.8923 3.5-3.6173 3.5-3.8923 3.5 1.0266-1.575 2.8923-3.5zm6-7c1.2918-1.375 2.5736-2.5 2.8486-2.5s-0.55688 1.125-1.8486 2.5-2.5736 2.5-2.8486 2.5 0.55688-1.125 1.8486-2.5zm6.3868-7.7966c2.1198-2.5869 4.0627-4.7034 4.3176-4.7034 0.68189 0-5.651 7.8489-7.0112 8.6895-0.63833 0.3945 0.57375-1.3992 2.6935-3.9861zm68.865-6.2034c0.0111-2.2 0.21589-2.9822 0.45508-1.7383s0.23011 3.0439-0.0202 4c-0.25029 0.95609-0.446-0.0617-0.4349-2.2617zm-422.25 2.1224c0-0.20765 0.7875-0.99515 1.75-1.75 1.5861-1.2439 1.6214-1.2085 0.37756 0.37756-1.3064 1.6658-2.1276 2.1955-2.1276 1.3724zm360.44-4.9513c1.5401-2.0191 3.0024-3.6712 3.2495-3.6712 0.69466 0-3.6346 5.8497-4.9148 6.6409-0.62418 0.38576 0.12518-0.95063 1.6652-2.9698zm10.201-14.671c2.5601-3.85 4.8402-7 5.067-7 0.53107 0-0.2119 1.2466-4.9171 8.25-2.1247 3.1625-4.0749 5.75-4.3338 5.75s1.6239-3.15 4.184-7zm50.671-9.5c6e-3 -3.3 0.1923-4.5294 0.41486-2.7321s0.21797 4.4974-0.0102 6c-0.22818 1.5026-0.41027 0.0321-0.40466-3.2679zm-42.31-3.5c0.5887-1.1 1.2954-2 1.5704-2s0.0183 0.9-0.57037 2c-0.5887 1.1-1.2954 2-1.5704 2s-0.0183-0.9 0.57037-2zm5-9c1.1224-2.2 2.2656-4 2.5406-4s-0.41829 1.8-1.5406 4-2.2656 4-2.5406 4 0.41829-1.8 1.5406-4zm5.0306-9.5c0-0.55 0.43621-1.675 0.96937-2.5s0.96937-1.05 0.96937-0.5-0.43621 1.675-0.96937 2.5-0.96937 1.05-0.96937 0.5zm5.0483-14.083c0.048-1.165 0.28494-1.4019 0.60416-0.60417 0.28887 0.72187 0.25335 1.5844-0.0789 1.9167-0.33229 0.33229-0.56864-0.25834-0.52522-1.3125zm1.0789-5.4167c0-1.375 0.22698-1.9375 0.50439-1.25s0.27741 1.8125 0 2.5-0.50439 0.125-0.50439-1.25zm0.0741-19c0-1.925 0.2058-2.7125 0.45733-1.75 0.25152 0.9625 0.25152 2.5375 0 3.5-0.25153 0.9625-0.45733 0.175-0.45733-1.75zm9.173 0.75-1.905-2.25 2.25 1.905c1.2375 1.0477 2.25 2.0602 2.25 2.25 0 0.80025-0.80479 0.20945-2.595-1.905z"/><path class="bagb-sq__sole" d="m239.5 904.29c-24.547-1.6994-56.141-11.072-83.394-24.74-39.786-19.953-70.24-45.449-86.461-72.384-6.9188-11.489-9.1339-18.489-12.102-38.241-1.4402-9.5856-3.5892-23.278-4.7755-30.428-2.662-16.044-2.7972-30.699-0.35913-38.94 1.844-6.2336 7.8907-19.009 9.4546-19.976 0.5025-0.31057 2.1564 1.1184 3.6753 3.1756s4.486 5.5491 6.5935 7.76c2.9318 3.0756 4.0742 5.307 4.8636 9.5 2.7082 14.384 11.736 23.946 22.636 23.975 1.5837 4e-3 2.8091 1.3882 4.7605 5.3767 5.3503 10.936 14.591 18.343 25.107 20.125 6.841 1.1596 7.231 1.4334 9.9454 6.9813 3.7724 7.7104 10.646 14.929 17.352 18.222 5.3059 2.6055 6.5374 2.7973 17.703 2.7567 11.738-0.0427 14.138-0.50594 25.622-4.945 1.205-0.46579 2.4005 0.75271 4.6507 4.7398 11.31 20.041 44.513 32.068 79.531 28.809 6.3066-0.58689 15.714-2.1445 20.905-3.4614 26.953-6.8371 42.606-18.008 69.498-49.599 10.52-12.358 15.949-16.672 30.793-24.468 24.066-12.639 40.297-25.392 48.887-38.413 2.402-3.6407 7.6445-12.694 11.65-20.119 8.5426-15.835 27.755-49.405 36.107-63.089 6.593-10.802 17.456-24.339 35.945-44.792 24.577-27.187 41.865-51.211 52.892-73.499 8.0524-16.276 9.3436-21.785 8.8463-37.745l-0.39582-12.704 2.5341 1.835c3.937 2.8508 11.417 10.993 14.998 16.326 6.4865 9.6593 7.2485 13.53 8.2035 41.668 0.476 14.025 0.9705 32.7 1.0989 41.5l0.23345 16-3.5406 8.5812c-8.7588 21.228-18.35 34.111-47.924 64.369-32.441 33.192-40.977 43.996-79.045 100.05-42.904 63.174-62.281 87.704-90.438 114.49-47.486 45.171-103.01 65.669-166.05 61.304z"/>';

  // Places the right traced foot art (shoe / sandal / sasquatch) on a leg tip.
  // Anchor = each art's sole-bottom-center so it sits on the ground; the left
  // foot mirrors via negative x-scale, and FOOT_TILT_DEG applies symmetrically.
  // Shoes recolor per shell; sandals recolor only the sole to the variant color;
  // sasquatch renders with its traced colors.
  function feetArtSvg(shell, laceHex, tipX, tipY, mirror) {
    // bx/by/bw/bh = art bounding box (local 688x1024 space) for the shade gradient.
    let paths, ax, ay, sclX, sclY, cls, style, flip = false, tilt = FOOT_TILT_DEG, tx = tipX, bx, by, bw, bh;
    if (shell.kind === 'sandal') {
      paths = SANDAL_PATHS; ax = SANDAL_ANCHOR_X; ay = SANDAL_ANCHOR_Y; sclX = sclY = SANDAL_SCALE; cls = 'bagb-sandal';
      tilt = SANDAL_TILT; tx = mirror ? 220 - SANDAL_FOOT_X : SANDAL_FOOT_X;
      bx = 109; by = 136; bw = 516; bh = 650;
      style = `--sandal-sole:${colorFor(shell.colorHandle || shell.title)}${shell.strapColor ? `;--sandal-strap:${colorFor(shell.strapColor)}` : ''}`;
    } else if (shell.kind === 'sasquatch') {
      // The sasquatch art was traced with the opposite chirality to the shoe/
      // sandal, so invert the mirror to keep both feet pointing the right way.
      // It also carries its own non-uniform scale, tilt, and tip x.
      // Yeti Feet reuse the art in their own colours (sampled from the product photo).
      paths = SASQUATCH_PATHS; ax = SASQUATCH_ANCHOR_X; ay = SASQUATCH_ANCHOR_Y; cls = 'bagb-sq';
      sclX = SASQUATCH_SCALE_X; sclY = SASQUATCH_SCALE_Y; tilt = SASQUATCH_TILT; flip = true;
      style = (shell.colorHandle || shell.handle || '').includes('yeti') ? YETI_ART_COLORS : '';
      tx = mirror ? 220 - SASQUATCH_FOOT_X : SASQUATCH_FOOT_X;
      bx = 50; by = 112; bw = 577; bh = 793;
    } else {
      const c = shoeRegionColors(shell, laceHex);
      paths = SHOE_PATHS; ax = SHOE_ANCHOR_X; ay = SHOE_ANCHOR_Y; sclX = sclY = FOOT_SCALE; cls = 'bagb-shoe';
      bx = 147; by = 122; bw = 411; bh = 679;
      style = `--shoe-body:${c.body};--shoe-toe:${c.toe};--shoe-vamp:${c.vamp};--shoe-collar:${c.collar};--shoe-insert:${c.insert};--shoe-lace:${c.lace}`;
    }
    const sx = (flip ? !mirror : mirror) ? -sclX : sclX;
    const transform = `translate(${tx} ${tipY}) scale(${sx} ${sclY}) translate(${-ax} ${-ay}) rotate(${tilt} ${ax} ${ay})`;
    // Shade the whole foot. The gradient x flips for mirrored feet (sx < 0) so
    // the light stays coming from the same screen direction on both feet.
    // The group's drop-shadow filter isolates the blend to the foot silhouette.
    let shade = '';
    if (SHADE_STRENGTH > 0) {
      const uid = ++feetShadeSeq;
      const gx1 = (sx < 0 ? 1 - SHADE_X1 : SHADE_X1).toFixed(3);
      const gx2 = (sx < 0 ? 1 - SHADE_X2 : SHADE_X2).toFixed(3);
      const y1 = SHADE_Y1.toFixed(3), y2 = SHADE_Y2.toFixed(3);
      shade = `<defs>`
        + `<linearGradient id="bsa${uid}" x1="${gx1}" y1="${y1}" x2="${gx2}" y2="${y2}"><stop offset="0" stop-color="#fff" stop-opacity="${SHADE_AL}"/><stop offset="0.47" stop-color="#fff" stop-opacity="0"/><stop offset="1" stop-color="#000" stop-opacity="${SHADE_AD}"/></linearGradient>`
        + `<linearGradient id="bsb${uid}" x1="${gx1}" y1="${y1}" x2="${gx2}" y2="${y2}"><stop offset="0.5" stop-color="#000" stop-opacity="0"/><stop offset="1" stop-color="#000" stop-opacity="${SHADE_BD}"/></linearGradient>`
        + `<clipPath id="bsc${uid}">${paths}</clipPath></defs>`
        + `<rect x="${bx}" y="${by}" width="${bw}" height="${bh}" fill="url(#bsa${uid})" clip-path="url(#bsc${uid})" style="mix-blend-mode:overlay"/>`
        + `<rect x="${bx}" y="${by}" width="${bw}" height="${bh}" fill="url(#bsb${uid})" clip-path="url(#bsc${uid})" style="mix-blend-mode:multiply"/>`;
    }
    return `<g class="${cls}" transform="${transform}" style="${style}">${paths}${shade}</g>`;
  }

  function initBagBuilder(root) {
    const params = new URLSearchParams(window.location.search);
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const instanceId = ++builderInstanceSeq;
    let bagSeq = 0;
    let cardSeq = 0;

    const state = {
      bags: [],
      // single-bag flow: 'build' (editor, default) → 'review' → 'added'
      screen: 'build',
      activeBagId: null,
      howOpen: false,
      stagePop: { bagId: null, kind: null },
      pendingPreselectShellId: null,
      drawer: {
        open: false,
        bagId: null,
        cardId: null,
        pendingShellVariantId: null,
        pendingLaceVariantId: null,
        filter: 'all',
        step: 'shoe',
        returnFocusEl: null
      }
    };

    const els = {
      list: root.querySelector('[data-bag-list]'),
      solo: root.querySelector('[data-bag-solo]'),
      buildScreen: root.querySelector('[data-screen-bag]'),
      reviewScreen: root.querySelector('[data-screen-review]'),
      reviewScrim: root.querySelector('.bagb-reviewscrim'),
      dock: root.querySelector('[data-bag-dock]'),
      bundle: root.querySelector('[data-bag-bundle]'),
      howSheet: root.querySelector('[data-how-sheet]'),
      heroTagline: root.querySelector('[data-hero-tagline]'),
      reviewOpen: root.querySelector('[data-review-open]'),
      reviewLabel: root.querySelector('[data-review-label]'),
      reviewSub: root.querySelector('[data-review-sub]'),
      checkout: root.querySelector('[data-bag-checkout]'),
      addedPanel: root.querySelector('[data-added-panel]'),
      total: root.querySelector('[data-bag-total]'),
      addCart: root.querySelector('[data-bag-add-cart]'),
      addLabel: root.querySelector('[data-bag-add-label]'),
      guide: root.querySelector('[data-size-guide]'),
      howGuide: root.querySelector('[data-how-guide]'),
      drawer: root.querySelector('[data-shell-drawer]'),
      drawerPanel: root.querySelector('[data-drawer-panel]'),
      drawerTitle: root.querySelector('[data-drawer-title]'),
      drawerBody: root.querySelector('[data-drawer-body]'),
      drawerPreview: root.querySelector('[data-drawer-preview]'),
      drawerConfirm: root.querySelector('[data-drawer-confirm]'),
      drawerRemove: root.querySelector('[data-drawer-remove]'),
      drawerBack: root.querySelector('[data-drawer-back]'),
      drawerTools: root.querySelector('[data-drawer-tools]')
    };

    // Color is an optional matching input ("None" chip is the default);
    // only the insert is required before picking shoes.
    function bagComplete(bag) {
      return !!(bag && bag.insertVariantId);
    }

    function cardShell(card) {
      return shellByVariant(card.shellVariantId);
    }

    function cardLace(card) {
      return card.laceVariantId ? laceByVariant(card.laceVariantId) : null;
    }

    function allCards() {
      return state.bags.flatMap(bag => bag.cards);
    }

    function selectedShellCount(variantId, excludeCardId) {
      return allCards().reduce((sum, card) => {
        if (card.id === excludeCardId) return sum;
        return sum + (card.shellVariantId === variantId ? 1 : 0);
      }, 0);
    }

    function selectedLaceCount(variantId, excludeCardId) {
      return allCards().reduce((sum, card) => {
        if (card.id === excludeCardId) return sum;
        return sum + (card.laceVariantId === variantId ? 1 : 0);
      }, 0);
    }

    function selectedInsertCount(variantId, excludeBagId) {
      return state.bags.reduce((sum, bag) => {
        if (bag.id === excludeBagId) return sum;
        return sum + (bag.insertVariantId === variantId ? 1 : 0);
      }, 0);
    }

    function canSelectShell(shell, cardId) {
      const max = Math.max(0, shell.inventoryQuantity || 0);
      return shell.active && shell.available && selectedShellCount(shell.variantId, cardId) < max;
    }

    function canSelectLace(lace, cardId) {
      const max = Math.max(0, lace.inventoryQuantity || 0);
      return lace.active && lace.available && selectedLaceCount(lace.variantId, cardId) < max;
    }

    function canSelectInsert(insert, bagId) {
      const max = Math.max(0, insert.inventoryQuantity || 0);
      return insert.active && insert.available && selectedInsertCount(insert.variantId, bagId) < max;
    }

    // Strict: only the insert that matches the chosen leg size. No silent
    // substitution — a "Small" bag must never ship with a Standard insert.
    function recommendedInsertForStand(standId, bagId) {
      const expected = standSize(standId)?.insert;
      if (!expected) return null;
      return usableInserts().find(insert => insert.title.toLowerCase() === expected && canSelectInsert(insert, bagId)) || null;
    }

    // Match = the shoe ECHOES the bag's own colors. Points for containing the
    // primary (or a near hue), fewer for the accent, a little for neutrals
    // (white/black go with anything) — and a penalty for unrelated colors, so
    // a plain White pair beats a Red/Black & White pair on a white bag.
    function shellMatchScore(shell, bag) {
      if (!bag || !bag.color) return 0;
      const primary = bag.color;
      const accent = bag.accentColor;
      const colors = shellColorList(shell);
      if (!colors.length) return 0;
      let score = 0;
      let primaryHit = false;
      let accentHit = false;
      colors.forEach(color => {
        if (color === primary) {
          score += 30;
          primaryHit = true;
        } else if (accent && color === accent) {
          score += 20;
          accentHit = true;
        } else if ((nearColors[primary] || []).includes(color)) {
          score += 15;
          primaryHit = true;
        } else if (accent && (nearColors[accent] || []).includes(color)) {
          score += 10;
          accentHit = true;
        } else if (color === 'white' || color === 'black') {
          score += 5;
        } else {
          score -= 18;
        }
      });
      if (primaryHit && accentHit) score += 12;
      return score;
    }

    function shellIsMatch(shell, bag) {
      return shell.available
        && Math.max(0, shell.inventoryQuantity || 0) > 0
        && shellMatchScore(shell, bag) >= 20;
    }

    function shellScoreForBag(shell, bag) {
      let score = shellMatchScore(shell, bag);
      if (shell.kind === 'shoe') score += 2;
      if (shell.available && Math.max(0, shell.inventoryQuantity || 0) > 0) score += 1000;
      return score;
    }

    function recommendedShellsForBag(bag, excludeCardId) {
      return usableShells()
        .filter(shell => shell.available && Math.max(0, shell.inventoryQuantity || 0) > selectedShellCount(shell.variantId, excludeCardId))
        .sort((a, b) => shellScoreForBag(b, bag) - shellScoreForBag(a, bag));
    }

    function shellMatchesBase(shell, baseHandle) {
      const normalizedBase = normalizeHandle(baseHandle);
      if (!normalizedBase) return false;
      const sourceHandles = Array.isArray(shell.sourceHandles) ? shell.sourceHandles.map(normalizeHandle) : [];
      if (sourceHandles.includes(normalizedBase)) return true;
      return normalizeHandle(shell.handle).includes(normalizedBase) || normalizedBase.includes(normalizeHandle(shell.colorHandle));
    }


    function defaultLaceForBag(bag, cardId) {
      const primary = bagColor(bag.color);
      const accent = bag.accentColor ? bagColor(bag.accentColor) : null;
      const tokens = [...new Set([...(primary?.laceTokens || []), ...(accent?.laceTokens || [])])];
      for (const token of tokens) {
        const lace = usableLaces().find(entry => normalizeHandle(entry.title).includes(token) && canSelectLace(entry, cardId));
        if (lace) return lace;
      }
      const white = usableLaces().find(lace => normalizeHandle(lace.title).includes('white') && canSelectLace(lace, cardId));
      return white || usableLaces().find(lace => canSelectLace(lace, cardId));
    }

    function ensureCardLace(bag, card) {
      const shell = cardShell(card);
      if (!shell || shell.kind !== 'shoe') {
        card.laceVariantId = null;
        return;
      }
      const selected = cardLace(card);
      if (selected && canSelectLace(selected, card.id)) return;
      card.laceVariantId = defaultLaceForBag(bag, card.id)?.variantId || null;
    }

    function createBag() {
      const id = ++bagSeq;
      // Bags start blank on purpose: no starter shell is auto-added anymore
      // (explicit "+ Add shell" flow). If conversion data ever argues for a
      // starter shell again, add it in confirmDrawer's add path.
      const bag = {
        id,
        name: `Bag ${id}`,
        color: null,
        accentColor: null,
        stand: null,
        insertVariantId: null,
        cards: [],
        previewCardId: null
      };
      state.bags.push(bag);
      return bag;
    }

    function initialShell() {
      const requestedVariant = params.get('shell');
      if (requestedVariant) {
        const byId = usableShells().find(shell => shell.variantId === requestedVariant);
        if (byId) return byId;
      }
      const baseHandle = params.get('base') || '';
      return usableShells().find(shell => shellMatchesBase(shell, baseHandle));
    }

    function addShellToBag(bag, variantId, laceVariantId) {
      const shell = shellByVariant(variantId);
      if (!shell || !canSelectShell(shell)) return;
      const card = { id: ++cardSeq, shellVariantId: variantId, laceVariantId: null };
      if (shell.kind === 'shoe' && laceVariantId) {
        const lace = laceByVariant(laceVariantId);
        if (lace && canSelectLace(lace, card.id)) card.laceVariantId = laceVariantId;
      }
      if (shell.kind === 'shoe' && !card.laceVariantId) {
        card.laceVariantId = defaultLaceForBag(bag, card.id)?.variantId || null;
      }
      bag.cards.push(card);
      bag.previewCardId = card.id;
    }

    function bagShoeCards(bag) {
      return bag.cards.filter(card => cardShell(card)?.kind === 'shoe');
    }

    // Full bag price: shells + insert + laces. Each is its own priced Shopify
    // variant (the cart already adds them as separate line items), so the
    // displayed total must include them. Today inserts/laces are $0 so this
    // equals the shell total; once they're priced it reflects the real cost.
    function bagTotal(bag) {
      let sum = 0;
      bag.cards.forEach(card => {
        const shell = cardShell(card);
        if (!shell) return;
        sum += shell.priceCents || 0;
        if (shell.kind === 'shoe') {
          const lace = cardLace(card);
          if (lace) sum += lace.priceCents || 0;
        }
      });
      const insert = insertByVariant(bag.insertVariantId);
      if (insert) sum += insert.priceCents || 0;
      return sum;
    }

    // Show a component's price, or "Included" while it's still priced at $0.
    function componentPrice(cents) {
      return cents > 0 ? money(cents) : 'Included';
    }

    function cartTotal() {
      return state.bags.reduce((sum, bag) => sum + bagTotal(bag), 0);
    }

    function validateBag(bag) {
      if (!bag.stand) return 'Pick an insert size.';
      if (!bag.insertVariantId || !insertByVariant(bag.insertVariantId)) {
        return `${standSize(bag.stand)?.title || 'That size'} inserts are out of stock.`;
      }
      if (!bag.cards.length) return 'Add at least one pair of shoes.';
      const missingLace = bagShoeCards(bag).find(card => !card.laceVariantId);
      if (missingLace) return 'Choose laces for every pair of shoes on this bag.';
      const overShell = bag.cards.find(card => {
        const shell = cardShell(card);
        return shell && selectedShellCount(shell.variantId) > Math.max(0, shell.inventoryQuantity || 0);
      });
      if (overShell) return `Reduce ${cardShell(overShell).title}. There are not enough pairs available.`;
      const overLace = bagShoeCards(bag).find(card => {
        const lace = cardLace(card);
        return lace && selectedLaceCount(lace.variantId) > Math.max(0, lace.inventoryQuantity || 0);
      });
      if (overLace) return `Reduce ${cardLace(overLace).title} laces. There are not enough available.`;
      const insert = insertByVariant(bag.insertVariantId);
      if (insert && selectedInsertCount(insert.variantId) > Math.max(0, insert.inventoryQuantity || 0)) {
        return `Reduce ${insert.title} inserts. There are not enough available.`;
      }
      return '';
    }

    function validationMessage() {
      const named = state.bags.length > 1;
      for (const bag of state.bags) {
        const message = validateBag(bag);
        if (message) return named ? `${bag.name}: ${message}` : message;
      }
      return '';
    }

    function validToCart() {
      return state.bags.length > 0 && !validationMessage();
    }

    /* ---------- bag visual ---------- */

    function isLightHex(hex) {
      if (!hex || hex.length < 7) return false;
      const r = parseInt(hex.slice(1, 3), 16);
      const g = parseInt(hex.slice(3, 5), 16);
      const b = parseInt(hex.slice(5, 7), 16);
      return (0.2126 * r + 0.7152 * g + 0.0722 * b) / 255 > 0.55;
    }

    // Detail lines must contrast with whatever fill the user picked: light
    // fills (white, yellow, pink) get navy lines, dark fills get off-white.
    function svgLineFor(hex) {
      return isLightHex(hex) ? 'rgba(10, 24, 87, 0.5)' : 'rgba(249, 248, 244, 0.55)';
    }

    function bagSvg(bag, idSuffix = '', repaint = false) {
      const primary = bag.color ? bagColor(bag.color) : null;
      const accent = bag.accentColor ? bagColor(bag.accentColor) : null;
      const insert = insertByVariant(bag.insertVariantId);
      const small = !!insert && insert.title.toLowerCase() === 'small';
      const styles = [];
      if (primary) {
        styles.push(`--bagp: ${primary.color}`);
        styles.push(`--bagp-line: ${svgLineFor(primary.color)}`);
        styles.push(`--baga-line: ${svgLineFor((accent || primary).color)}`);
      }
      if (accent) styles.push(`--baga: ${accent.color}`);
      const label = primary
        ? `${primary.label}${accent ? ` and ${accent.label}` : ''} golf stand bag${insert ? ` with ${insert.title} inserts glowing on the ${small ? 'narrow' : 'standard'} stand legs` : ''}`
        : 'Golf stand bag silhouette, waiting for a color';
      const clipId = `bagbClip${instanceId}-${bag.id}${idSuffix}`;
      const footClipId = `bagbFootClip${instanceId}-${bag.id}${idSuffix}`;
      const chromeId = `bagbChrome${instanceId}-${bag.id}${idSuffix}`;
      const bodyPath = 'M78 54 h64 a14 14 0 0 1 14 14 v182 a14 14 0 0 1 -14 14 h-64 a14 14 0 0 1 -14 -14 V68 a14 14 0 0 1 14 -14 z';
      // Leg-end coordinates, read from .bagb-svg__legs below: left leg runs
      // 78,112 -> 29,272; right leg runs 142,112 -> 191,272. Feet badges sit
      // on those tips (viewBox is 220x300, not the 200x300 the brief assumed).
      const LEFT_X = 29;
      const LEFT_Y = 272;
      const RIGHT_X = 191;
      const RIGHT_Y = 272;
      const preview = previewShellFor(bag);
      // PROTOTYPE: dynamic vector shoe recolored from the previewed pair's
      // shell colors + lace (replaces the hardcoded cutout test images).
      const feetShell = preview && preview.shell;
      const feetLace = feetShell && feetShell.kind === 'shoe' && preview.card ? cardLace(preview.card) : null;
      const feetLaceHex = feetLace ? colorFor(feetLace.colorHandle || feetLace.title) : null;
      // Traced 3/4 shoe (viewBox 688x1024) scaled down onto the two leg tips;
      // anchor is its sole-bottom-center so both sit on the ground. Left foot is
      // mirrored; right foot sits at x196 per the tuned transform.
      const FOOT_Y = 290;
      const LEFT_FOOT_X = 30;
      const RIGHT_FOOT_X = 190;
      void LEFT_X; void LEFT_Y; void RIGHT_Y; void RIGHT_X;
      const feet = feetShell ? `
        <g class="bagb-svg__feet">
          ${feetArtSvg(feetShell, feetLaceHex, LEFT_FOOT_X, FOOT_Y, true)}
          ${feetArtSvg(feetShell, feetLaceHex, RIGHT_FOOT_X, FOOT_Y, false)}
        </g>` : '';
      void footClipId;
      void clipId; void bodyPath;
      return `
        <svg class="bagb-svg${insert ? ' has-insert' : ''}${small ? ' is-small' : ''}${repaint ? ' is-painting' : ''}" viewBox="0 0 220 300" role="img" aria-label="${escapeHtml(label)}" style="${styles.join('; ')}">
          <defs><linearGradient id="${chromeId}" x1="0" y1="0" x2="0" y2="1"><stop class="bagb-svg__chrome-hi" offset="0"/><stop class="bagb-svg__chrome-mid" offset=".55"/><stop class="bagb-svg__chrome-lo" offset="1"/></linearGradient></defs>
          <ellipse class="bagb-svg__shadow" cx="110" cy="289" rx="88" ry="8"/>
          <g transform="translate(110 0) scale(1.14 1) translate(-110 0)">
          <path class="bagb-svg__pocket" d="M79 130 Q64 135 61 176 L64 226 Q66 240 74 240 L79 236 Z"/>
          <path class="bagb-svg__pocket" d="M141 130 Q156 135 159 176 L156 226 Q154 240 146 240 L141 236 Z"/>
          <path class="bagb-svg__ptrim" d="M79 131 Q65 136 62 172"/>
          <path class="bagb-svg__ptrim" d="M141 131 Q155 136 158 172"/>
          <path class="bagb-svg__base" d="M78 244 L142 244 L140 268 Q140 272 135 272 L85 272 Q80 272 80 268 Z"/>
          <path class="bagb-svg__dark" d="M84 262 L136 262 L134 270 Q134 274 129 274 L91 274 Q86 274 86 270 Z"/>
          <rect class="bagb-svg__foot" x="86" y="272" width="10" height="6" rx="2"/>
          <rect class="bagb-svg__foot" x="124" y="272" width="10" height="6" rx="2"/>
          <g class="bagb-svg__body"><path d="M77 74 Q77 70 83 70 L137 70 Q143 70 143 74 L141 250 Q141 258 131 259 L89 259 Q79 258 79 250 Z"/></g>
          <g class="bagb-svg__accent">
            <path d="M80 84 L84 78 L92 78 L96 84 L96 224 L88 246 L80 224 Z"/>
            <path d="M140 84 L136 78 L128 78 L124 84 L124 224 L132 246 L140 224 Z"/>
          </g>
          <path class="bagb-svg__stitch" d="M98 84 L98 222"/>
          <path class="bagb-svg__stitch" d="M122 84 L122 222"/>
          <path class="bagb-svg__stitch" d="M80 84 L84 78 L92 78 L96 84 L96 224 L88 246 L80 224 Z"/>
          <path class="bagb-svg__stitch" d="M140 84 L136 78 L128 78 L124 84 L124 224 L132 246 L140 224 Z"/>
          <path class="bagb-svg__hi" d="M79 76 L90 78 L88 250 L80 249 Z"/>
          <path class="bagb-svg__shade" d="M118 74 L141 74 L139 252 Q139 258 131 259 L118 259 Z"/>
          <path class="bagb-svg__shade" d="M141 130 Q156 135 159 176 L156 226 Q154 240 146 240 L141 236 Z"/>
          <path class="bagb-svg__zip" d="M67 155 Q62 185 66 218"/>
          <path class="bagb-svg__zip" d="M153 155 Q158 185 154 218"/>
          <rect class="bagb-svg__tab" x="79" y="138" width="6" height="26" rx="2"/>
          <rect class="bagb-svg__tab" x="135" y="138" width="6" height="26" rx="2"/>
          <path class="bagb-svg__pocket" d="M92 196 L128 196 Q133 196 133 204 L131 244 Q131 250 124 250 L96 250 Q89 250 89 244 L87 204 Q87 196 92 196 Z"/>
          <path class="bagb-svg__stitch" d="M92 196 L128 196 Q133 196 133 204 L131 244 Q131 250 124 250 L96 250 Q89 250 89 244 L87 204 Q87 196 92 196 Z"/>
          <path class="bagb-svg__zip" d="M96 202 L124 202"/>
          <path class="bagb-svg__strap" d="M105 110 L115 110 L114 198 Q114 204 110 204 Q106 204 106 198 Z"/>
          <rect class="bagb-svg__strap" x="101" y="192" width="18" height="13" rx="4"/>
          <path class="bagb-svg__strap" d="M100 76 Q110 72 120 76 L122 106 Q122 113 115 113 L105 113 Q98 113 98 106 Z"/>
          <path class="bagb-svg__stitch" d="M103 82 L117 104 M117 82 L103 104"/>
          <path class="bagb-svg__dark" d="M78 62 Q78 50 110 50 Q142 50 142 62 L142 68 Q142 74 134 74 L86 74 Q78 74 78 68 Z"/>
          <g class="bagb-svg__mouth"><ellipse cx="110" cy="55" rx="29" ry="6.5"/></g>
          <g class="bagb-svg__clubs">
            <line class="bagb-svg__shaft-u" x1="102" y1="60" x2="86" y2="17"/>
            <line class="bagb-svg__shaft" x1="102" y1="60" x2="86" y2="17"/>
            <path class="bagb-svg__hosel" d="M87.5 18.5 L85.5 14.5"/>
            <path class="bagb-svg__driver" d="M86.5 16 C 86.6 21 80 25.2 71.5 24.8 C 62.5 24.4 57.8 19 59.4 13 C 61 7.2 68.8 3.6 77.2 4.6 C 84.6 5.5 88.6 9.8 86.5 16 Z"/>
            <path class="bagb-svg__face" d="M86.6 15.4 C 86.4 20.6 80.2 24.8 72 24.8"/>
            <path class="bagb-svg__crown-hi" d="M63.5 11.5 C 67 7.4 74.5 6 81 7.6"/>
            <line class="bagb-svg__shaft-u" x1="110" y1="60" x2="111" y2="31"/>
            <line class="bagb-svg__shaft" x1="110" y1="60" x2="111" y2="31"/>
            <path class="bagb-svg__chrome" fill="url(#${chromeId})" d="M109.6 32 L109.4 27.2 L121.5 18.6 Q126.2 15.8 128 19.4 L125.6 29.6 Q124.4 33.4 120.2 33 L111.6 32.6 Z"/>
            <path class="bagb-svg__groove" d="M113.6 27.4 l9.8 -6.4 M114.2 30.2 l9.6 -6 M115.2 32.4 l8.6 -5.4"/>
            <line class="bagb-svg__shaft-u" x1="123" y1="60" x2="129.5" y2="40"/>
            <line class="bagb-svg__shaft" x1="123" y1="60" x2="129.5" y2="40"/>
            <path class="bagb-svg__hosel" d="M129.5 40 L131.8 36.4 L134.6 35.4"/>
            <path class="bagb-svg__chrome" fill="url(#${chromeId})" d="M128.4 36.6 L153.2 32.4 Q156 32 156.3 34.8 L156.8 38.6 Q157 41.2 154.4 41.6 L129.4 45.4 Q126.8 45.8 126.6 43.2 L126.2 39.6 Q126 37 128.4 36.6 Z"/>
            <line class="bagb-svg__sight" x1="139.6" y1="35.6" x2="143.8" y2="34.9"/>
          </g>
          </g>
          <g class="bagb-svg__legs">
            <line class="bagb-svg__leg-under" x1="84" y1="100" x2="35" y2="272"/>
            <line class="bagb-svg__leg" x1="84" y1="100" x2="35" y2="272"/>
            <line class="bagb-svg__leg-under" x1="136" y1="100" x2="185" y2="272"/>
            <line class="bagb-svg__leg" x1="136" y1="100" x2="185" y2="272"/>
          </g>
          <g class="bagb-svg__trim"><circle cx="84" cy="100" r="4"/><circle cx="136" cy="100" r="4"/></g>
          ${feet}
        </svg>`;
    }

    /* ---------- bag cards ---------- */

    function swatchRowHtml(bag, type) {
      const isAccent = type === 'accent';
      const current = isAccent ? bag.accentColor : bag.color;
      const attr = isAccent ? 'data-bag-accent' : 'data-bag-color';
      const noneLabel = isAccent ? 'No accent color' : 'No color (skip matching)';
      const noneTitle = isAccent ? 'No accent' : 'No color';
      const noneChip = `<button type="button" class="bagb-swatch bagb-swatch--none${current == null ? ' is-selected' : ''}" role="radio" aria-checked="${current == null}" ${attr}="none" aria-label="${noneLabel}" title="${noneTitle}">${current == null ? '<span class="bagb-swatch__check" aria-hidden="true">&#10003;</span>' : ''}</button>`;
      const chips = bagColors.map(color => {
        const selected = current === color.id;
        return `<button type="button" class="bagb-swatch${selected ? ' is-selected' : ''}${isLightHex(color.color) ? ' is-light' : ''}" role="radio" aria-checked="${selected}" ${attr}="${color.id}" style="--sw: ${color.color}" aria-label="${escapeHtml(color.label)}" title="${escapeHtml(color.label)}">${selected ? '<span class="bagb-swatch__check" aria-hidden="true">&#10003;</span>' : ''}</button>`;
      }).join('');
      return `<div class="bagb-swatches" role="radiogroup" aria-label="${isAccent ? 'Accent color' : 'Bag color'}">${noneChip}${chips}</div>`;
    }

    function standChipHtml(bag, size) {
      const selected = bag.stand === size.id;
      const available = selected || !!recommendedInsertForStand(size.id, bag.id);
      return `
        <button type="button" class="bagb-stand${selected ? ' is-selected' : ''}" role="radio" aria-checked="${selected}" data-bag-stand="${size.id}" ${available ? '' : 'disabled'}>
          <strong>${escapeHtml(size.title)}</strong>
          <span>${available ? escapeHtml(size.hint) : 'Out of stock'}</span>
        </button>`;
    }

    const pencilSvg = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M17 3a2.8 2.8 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5z"/></svg>';
    const paletteSvg = '<svg class="bagb-stagebtn__palette" viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 2a10 10 0 1 0 0 20c1.4 0 2-1 2-2 0-.6-.3-1-.6-1.5-.3-.4-.4-.8-.4-1.2a1.5 1.5 0 0 1 1.5-1.5H16a5 5 0 0 0 5-5c0-4.4-4-9-9-9z"/><circle cx="7.5" cy="10.5" r="1.1" fill="currentColor" stroke="none"/><circle cx="12" cy="7.5" r="1.1" fill="currentColor" stroke="none"/><circle cx="16.5" cy="10.5" r="1.1" fill="currentColor" stroke="none"/></svg>';

    function shellThumbHtml(shell) {
      if (!shell) return '';
      const media = shell.image
        ? `<img class="bagb-sum__thumb" src="${escapeHtml(shell.image)}" alt="${escapeHtml(shell.title)}" loading="lazy">`
        : `<span class="bagb-sum__thumb" aria-hidden="true"></span>`;
      return `<span class="bagb-thumbwrap" data-thumb-title="${escapeHtml(shell.title)}" tabindex="0">${media}</span>`;
    }

    // Shopify CDN transform: keeps thumbs light, converts formats browsers
    // can't decode natively (the insert photo is a HEIC original), and
    // center-crops the portrait shot into a true square tile.
    function resizedImage(url, width) {
      if (!url) return url;
      return `${url}${url.includes('?') ? '&' : '?'}width=${width}&height=${width}&crop=center`;
    }

    function insertThumbHtml(bag) {
      const insert = insertByVariant(bag.insertVariantId) || usableInserts()[0];
      if (!insert || !insert.image) return '';
      return `<span class="bagb-thumbwrap bagb-insertthumb" data-thumb-title="${escapeHtml(insert.title)} insert" tabindex="0"><img class="bagb-insertthumb__img" src="${escapeHtml(resizedImage(insert.image, 480))}" alt="${escapeHtml(insert.title)} insert" loading="lazy"></span>`;
    }

    function syncPopLock() {
      const sheetOpen = (!!state.stagePop.kind || state.howOpen || state.screen === 'review') && window.matchMedia('(max-width: 767px)').matches;
      if (sheetOpen) document.body.classList.add('bagb-lock');
      else if (!state.drawer.open) document.body.classList.remove('bagb-lock');
    }

    function stagePopoverHtml(bag) {
      if (state.stagePop.bagId !== bag.id || !state.stagePop.kind) return '';
      const closeBtn = '<button type="button" class="bagb-pop__close" data-pop-close aria-label="Close">&times;</button>';
      if (state.stagePop.kind === 'color') {
        const primary = bag.color ? bagColor(bag.color) : null;
        const accent = bag.accentColor ? bagColor(bag.accentColor) : null;
        const matchCount = primary ? usableShells().filter(shell => shellIsMatch(shell, bag)).length : 0;
        return `
          <div class="bagb-pop__scrim" aria-hidden="true"></div>
          <div class="bagb-pop bagb-pop--color" data-stage-pop role="dialog" aria-label="Bag color">
            <div class="bagb-subhead">
              <span class="bagb-sublabel">Your bag&rsquo;s color</span>
              <span class="bagb-pop__tools">${closeBtn}</span>
            </div>
            <div class="bagb-panelwell bagb-pop__introwell">
              <span class="bagb-colorpreview${primary ? '' : ' is-empty'}" style="--sw1: ${primary ? primary.color : 'transparent'}; --sw2: ${(accent || primary) ? (accent || primary).color : 'transparent'}" aria-hidden="true"></span>
              <div class="bagb-colorpreview__info">
                <strong>${primary ? `${escapeHtml(primary.label)}${accent ? ` &amp; ${escapeHtml(accent.label)}` : ''}` : 'No color set'}</strong>
                <span>${primary
                  ? `${matchCount ? `${matchCount} matching ${matchCount === 1 ? 'pair' : 'pairs'}` : 'No matches in stock'} &middot; we sort them first`
                  : 'Optional. Set it and we&rsquo;ll match shoes to your bag.'}</span>
              </div>
            </div>
            <div class="bagb-panelwell">
              <span class="bagb-sublabel">Main color</span>
              ${swatchRowHtml(bag, 'color')}
            </div>
            <div class="bagb-panelwell">
              <span class="bagb-sublabel">Accent <span class="bagb-optional">optional</span></span>
              ${swatchRowHtml(bag, 'accent')}
            </div>
          </div>`;
      }
      return `
        <div class="bagb-pop__scrim" aria-hidden="true"></div>
        <div class="bagb-pop bagb-pop--insert" data-stage-pop role="dialog" aria-label="Insert size">
          <div class="bagb-subhead">
            <span class="bagb-sublabel">Insert size</span>
            <span class="bagb-pop__tools">
              <button type="button" class="bagb-link" data-size-guide-open>Size guide</button>
              ${closeBtn}
            </span>
          </div>
          <div class="bagb-panelwell bagb-pop__introwell">
            ${insertThumbHtml(bag)}
            <p class="bagb-pop__note">One insert per bag. Every shell snaps onto it. Swap them anytime.</p>
          </div>
          <div class="bagb-panelwell bagb-pop__sizewell">
            <span class="bagb-sublabel">Pick your size</span>
            <div class="bagb-stands" role="radiogroup" aria-label="Insert size">
              ${standSizes.map(size => standChipHtml(bag, size)).join('')}
            </div>
          </div>
          <button type="button" class="bagb-pop__continue" data-pop-close ${bag.stand ? '' : 'disabled'}>Continue</button>
        </div>`;
    }

    function previewShellFor(bag) {
      const card = bag.cards.find(entry => entry.id === bag.previewCardId) || bag.cards[bag.cards.length - 1] || null;
      return card ? { card, shell: cardShell(card) } : null;
    }

    function bagStripHtml(bag) {
      if (!bag.cards.length) return '';
      const previewed = previewShellFor(bag);
      const previewedId = previewed?.card.id ?? null;
      const thumbs = bag.cards.map(card => {
        const shell = cardShell(card);
        if (!shell) return '';
        const isOn = card.id === previewedId;
        const lace = shell.kind === 'shoe' ? cardLace(card) : null;
        return `
          <div class="bagb-stripthumb${isOn ? ' is-on-bag' : ''}">
            <button type="button" class="bagb-stripthumb__btn" data-preview-card="${card.id}" aria-pressed="${isOn}" aria-label="Show ${escapeHtml(shell.title)} on the bag">
              ${shell.image ? `<img src="${escapeHtml(resizedImage(shell.image, 240))}" alt="" loading="lazy">` : ''}
              ${lace ? `<span class="bagb-stripthumb__lace" style="--sw: ${colorFor(lace.colorHandle || lace.title)}" title="${escapeHtml(lace.title)} laces"></span>` : ''}
            </button>
            ${isOn ? `<button type="button" class="bagb-chip__edit bagb-stripthumb__edit" data-card-edit="${card.id}" aria-label="Edit ${escapeHtml(shell.title)}">${pencilSvg}</button>` : ''}
            ${isOn ? '<span class="bagb-stripthumb__tag">On bag</span>' : ''}
          </div>`;
      }).join('');
      return thumbs
        ? `<div class="bagb-pairbar">
            <div class="bagb-pairbar__row">${thumbs}</div>
          </div>`
        : '';
    }

    function bagCardHtml(bag, repaint) {
      const insert = insertByVariant(bag.insertVariantId);
      const issue = validateBag(bag);
      const stockIssue = issue && bag.stand && !issue.startsWith('Pick') && !issue.startsWith('Add at least') ? issue : '';
      const docked = bag.cards.length > 0;
      void insert;
      const primary = bag.color ? bagColor(bag.color) : null;
      const accent = bag.accentColor ? bagColor(bag.accentColor) : null;
      const colorOpen = state.stagePop.bagId === bag.id && state.stagePop.kind === 'color';
      return `
        <div class="bagb-stage${docked ? ' is-docked' : ''}">
          <button type="button" class="bagb-stagebtn bagb-stagebtn--how" data-how-sheet-open>
            <span class="bagb-stagebtn__q" aria-hidden="true">?</span> How it works
          </button>
          <button type="button" class="bagb-stagebtn bagb-stagebtn--color${primary ? ' is-set' : ''}" data-pop-toggle="color" aria-expanded="${colorOpen}">
            ${primary
              ? `Color <span class="bagb-stagebtn__dot" style="--sw1: ${primary.color}; --sw2: ${(accent || primary).color}"></span>`
              : `${paletteSvg} Color`}
          </button>
          <div class="bagb-stage__art">${bagSvg(bag, 'card', repaint)}</div>
          <div class="bagb-stage__strip" data-bag-strip>${bagStripHtml(bag)}</div>
          ${stagePopoverHtml(bag)}
        </div>
        ${stockIssue ? `<p class="bagb-card__issue">${escapeHtml(stockIssue)}</p>` : ''}`;
    }

    // Sticky dock: the two build steps. Color + How live on the stage.
    function dockHtml(bag) {
      const insert = insertByVariant(bag.insertVariantId);
      const canShoes = bagComplete(bag);
      const count = bag.cards.length;
      const lockSvg = '<svg class="bagb-dockbtn__lock" viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><rect x="5" y="11" width="14" height="9" rx="2"/><path d="M8 11V8a4 4 0 0 1 8 0v3"/></svg>';
      const caretSvg = '<svg class="bagb-dockbtn__caret" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M6 15l6-6 6 6"/></svg>';
      const checkSvg = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="3.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12l5 5L19 7"/></svg>';
      return `
        <button type="button" class="bagb-dockbtn${insert ? ' is-set' : ' is-required'}" data-dock="insert">
          <span class="bagb-dockbtn__step" aria-hidden="true">${insert ? checkSvg : '1'}</span>
          ${caretSvg}
          <span class="bagb-dockbtn__label">Insert</span>
          <span class="bagb-dockbtn__sep" aria-hidden="true"></span>
          <span class="bagb-dockbtn__status">${insert ? escapeHtml(insert.title) : 'Pick size'}</span>
        </button>
        <button type="button" class="bagb-dockbtn${count ? ' is-set' : (canShoes && !count ? ' is-required' : '')}" data-dock="shoes" ${canShoes ? '' : 'disabled'}>
          <span class="bagb-dockbtn__step" aria-hidden="true">${count ? checkSvg : '2'}</span>
          ${canShoes ? caretSvg : ''}
          <span class="bagb-dockbtn__label">Shoes</span>
          <span class="bagb-dockbtn__sep" aria-hidden="true"></span>
          <span class="bagb-dockbtn__status">${count ? plural(count, 'pair', 'pairs') : (canShoes ? 'Add pair' : `${lockSvg} Insert first`)}</span>
        </button>`;
    }

    function renderDock() {
      const bag = activeBag();
      if (els.dock && bag) els.dock.innerHTML = dockHtml(bag);
    }

    // Order-summary rail (design A): grouped Insert / Shoes rows —
    // thumb · name/detail · price. The card chrome (title, sub, total, Add to
    // Cart) is owned by the review markup, so this renders only the item list.
    const bbrEmptyThumb = '<span class="bbr-thumb__ph" aria-hidden="true">?</span>';

    function bbrItem(imgHtml, name, detail, price) {
      return `
        <div class="bbr-item">
          <span class="bbr-thumb">${imgHtml}</span>
          <span class="bbr-meta">
            <strong class="bbr-name">${name}</strong>
            ${detail ? `<span class="bbr-detail">${detail}</span>` : ''}
          </span>
          ${price ? `<span class="bbr-price">${price}</span>` : ''}
        </div>`;
    }

    function bundleHtml(bag) {
      const insert = insertByVariant(bag.insertVariantId);
      const insertRow = insert
        ? bbrItem(
            insert.image ? `<img src="${escapeHtml(resizedImage(insert.image, 160))}" alt="" loading="lazy">` : bbrEmptyThumb,
            `${escapeHtml(insert.title)} insert`, 'One per bag', componentPrice(insert.priceCents))
        : bbrItem(bbrEmptyThumb, 'No size yet', 'Pick an insert size', '');

      const shoeRows = bag.cards.length
        ? bag.cards.map(card => {
            const shell = cardShell(card);
            if (!shell) return '';
            const lace = shell.kind === 'shoe' ? cardLace(card) : null;
            const detail = lace
              ? `${escapeHtml(lace.title)} laces${lace.priceCents > 0 ? ` &middot; ${money(lace.priceCents)}` : ''}`
              : escapeHtml(shellKindLabel(shell));
            return bbrItem(
              shell.image ? `<img src="${escapeHtml(resizedImage(shell.image, 160))}" alt="" loading="lazy">` : bbrEmptyThumb,
              escapeHtml(shell.title), detail, money(shell.priceCents));
          }).join('')
        : bbrItem(bbrEmptyThumb, 'No pairs yet', 'Add at least one pair', '');

      return `
        <p class="bbr-group">Insert</p>
        ${insertRow}
        <p class="bbr-group">Shoes</p>
        ${shoeRows}`;
    }

    function renderBundle() {
      const bag = activeBag();
      if (!bag) return;
      if (els.bundle) els.bundle.innerHTML = bundleHtml(bag);
      if (els.reviewSub) {
        const pairs = bag.cards.length;
        els.reviewSub.textContent = bag.insertVariantId
          ? `1 insert${pairs ? ` · ${plural(pairs, 'pair', 'pairs')}` : ''}`
          : 'Pick a size to start';
      }
    }

    function activeBag() {
      return state.bags.find(bag => bag.id === state.activeBagId) || null;
    }

    function bagRowHtml(bag) {
      const complete = !validateBag(bag);
      const insertSet = !!bag.stand;
      const shoesSet = bag.cards.length > 0;
      const tick = '<span class="bagb-bar__tick" aria-hidden="true">&#10003;</span>';

      // Each stat sits in its own recessed well so it reads as a distinct group.
      // Wells always render (equipped or not) — an empty bag shows muted prompts
      // rather than a hole, so the card never looks empty and never crams.
      const insertVal = insertSet
        ? `${escapeHtml(standSize(bag.stand)?.title || 'Set')} ${tick}`
        : '<span class="bagb-ovcard__muted">Pick a size</span>';

      let shoesVal;
      if (shoesSet) {
        const firstShell = cardShell(bag.cards[0]);
        const thumb = firstShell?.image
          ? `<img class="bagb-ovcard__thumb" src="${escapeHtml(resizedImage(firstShell.image, 160))}" alt="" loading="lazy">`
          : '';
        shoesVal = `${thumb}<span>${plural(bag.cards.length, 'pair', 'pairs')}</span>`;
      } else {
        shoesVal = '<span class="bagb-ovcard__muted">None yet</span>';
      }

      // header right: the total once complete, otherwise a status pill; the
      // footer doubles as the tap-to-edit affordance.
      const headRight = complete
        ? `<span class="bagb-ovcard__price">${money(bagTotal(bag))}</span>`
        : '<span class="bagb-ovcard__pill">In progress</span>';
      const footLabel = complete ? 'Edit bag' : 'Start this bag';

      return `
        <div class="bagb-row">
          <button type="button" class="bagb-ovcard${complete ? ' is-complete' : ''}" data-bag-edit="${bag.id}" aria-label="Edit ${escapeHtml(bag.name)}">
            <span class="bagb-ovcard__head">
              <span class="bagb-ovcard__name">${escapeHtml(bag.name)}</span>
              ${headRight}
            </span>
            <span class="bagb-ovcard__body">
              <span class="bagb-ovcard__preview" aria-hidden="true">${bagSvg(bag, `row${bag.id}`, false)}</span>
              <span class="bagb-ovcard__specs">
                <span class="bagb-ovcard__well">
                  <span class="bagb-ovcard__k">Insert</span>
                  <span class="bagb-ovcard__sep" aria-hidden="true"></span>
                  <span class="bagb-ovcard__v">${insertVal}</span>
                </span>
                <span class="bagb-ovcard__well">
                  <span class="bagb-ovcard__k">Shoes</span>
                  <span class="bagb-ovcard__sep" aria-hidden="true"></span>
                  <span class="bagb-ovcard__v">${shoesVal}</span>
                </span>
              </span>
            </span>
            <span class="bagb-ovcard__foot"><span class="bagb-ovcard__footlabel">${footLabel}</span><span class="bagb-ovcard__chev" aria-hidden="true">&rsaquo;</span></span>
          </button>
          ${state.bags.length > 1 ? `<button type="button" class="bagb-card__remove bagb-row__remove" data-bag-remove="${bag.id}" aria-label="Remove ${escapeHtml(bag.name)}">&times;</button>` : ''}
        </div>`;
    }

    function renderOverview() {
      if (!els.list) return;
      els.list.innerHTML = state.bags.map(bag => bagRowHtml(bag)).join('')
        + '<button type="button" class="bagb-add-card" data-bag-add><span class="bagb-add-card__plus" aria-hidden="true">+</span><span class="bagb-add-card__label">Add a bag</span></button>';
    }

    function renderSolo() {
      const bag = activeBag();
      if (!els.solo || !bag) return;
      els.solo.dataset.bagCard = String(bag.id);
      const paintKey = `${bag.id}~${bag.color || ''}~${bag.accentColor || ''}~${bag.previewCardId ?? ''}`;
      const repaint = els.solo.dataset.paint !== paintKey;
      els.solo.dataset.paint = paintKey;
      els.solo.innerHTML = bagCardHtml(bag, repaint);
      els.solo.querySelectorAll('.bagb-swatches').forEach(row => {
        const selected = row.querySelector('.is-selected');
        if (!selected) return;
        const delta = selected.getBoundingClientRect().left - row.getBoundingClientRect().left;
        row.scrollLeft += delta - (row.clientWidth - selected.offsetWidth) / 2;
      });
    }

    // Review screen: total + Add to Cart (single bag).
    function renderSummary() {
      if (els.total) els.total.textContent = money(cartTotal());
      if (els.addCart) els.addCart.disabled = !validToCart();
      if (els.addLabel) els.addLabel.textContent = 'Add to Cart';
    }

    // Build screen: the "Review bundle · $XX" CTA carries the live total and
    // stays disabled until the bag is complete.
    function renderReviewButton() {
      if (!els.reviewOpen) return;
      const ok = validToCart();
      els.reviewOpen.disabled = !ok;
      if (els.reviewLabel) {
        els.reviewLabel.textContent = ok ? `Review bundle · ${money(cartTotal())}` : 'Complete your bag';
      }
    }

    function render() {
      state.bags.forEach(bag => {
        bag.cards.forEach(card => ensureCardLace(bag, card));
      });
      const activeb = !!activeBag();
      const building = state.screen === 'build' && activeb;
      const added = state.screen === 'added';
      // Keep the editor in its full-height "editing" layout whenever a bag is
      // active — even while the review sheet is open — so the bag never jumps
      // or resizes behind the sheet on mobile.
      root.classList.toggle('bagb--editing', activeb);

      // Render every surface each pass so the mobile screen-swap AND the desktop
      // side-by-side layout (bag editor + picks rail) both stay in sync.
      if (activeb) { renderSolo(); renderDock(); renderReviewButton(); }
      renderBundle();
      renderSummary();

      // Mobile: the bag editor stays visible; the review is a bottom-sheet
      // overlay (with a scrim) shown only in the 'review' screen. Desktop CSS
      // forces both columns visible side by side regardless.
      const reviewing = state.screen === 'review';
      if (els.buildScreen) els.buildScreen.hidden = !activeb;
      if (els.reviewScreen) els.reviewScreen.hidden = !reviewing;
      if (els.reviewScrim) els.reviewScrim.hidden = !reviewing;
      if (els.checkout) els.checkout.hidden = added;
      if (els.addedPanel) els.addedPanel.hidden = !added;
      if (els.heroTagline) els.heroTagline.hidden = building;

      // How It Works is a bottom sheet opened from the dock; its video plays
      // only while the sheet is open.
      if (els.howSheet) {
        const open = building && state.howOpen;
        els.howSheet.hidden = !open;
        const video = els.howSheet.querySelector('video');
        if (video) {
          if (open) video.play?.().catch(() => {});
          else video.pause?.();
        }
      }
    }

    /* ---------- drawer ---------- */

    function drawerBag() {
      return state.bags.find(bag => bag.id === state.drawer.bagId) || null;
    }

    function shellPickHtml(shell, isMatch) {
      const selected = state.drawer.pendingShellVariantId === shell.variantId;
      const usable = selected || canSelectShell(shell, state.drawer.cardId ?? undefined);
      const out = !shell.available || Math.max(0, shell.inventoryQuantity || 0) < 1;
      return `
        <button type="button" class="bagb-pick${selected ? ' is-selected' : ''}${out ? ' is-out' : ''}" role="radio" aria-checked="${selected}" data-drawer-shell="${escapeHtml(shell.variantId)}" ${!usable ? 'disabled' : ''}>
          <span class="bagb-pick__media">
            ${shell.image ? `<img src="${escapeHtml(resizedImage(shell.image, 400))}" alt="" loading="lazy">` : ''}
            ${isMatch && !out ? '<span class="bagb-pick__match" aria-hidden="true">Match</span>' : ''}
            ${out ? '<span class="bagb-pick__out">Sold out</span>' : ''}
            <span class="bagb-stitch" aria-hidden="true"></span>
          </span>
          <span class="bagb-pick__body">
            <span class="bagb-pick__title">${escapeHtml(shell.title)}</span>
            <span class="bagb-pick__meta">${money(shell.priceCents)}</span>
            ${shell.kind === 'shoe' ? '' : `<span class="bagb-pick__kind">${escapeHtml(shellKindLabel(shell))}</span>`}
          </span>
          ${selected ? '<span class="bagb-pick__badge" aria-hidden="true">&#10003;</span>' : ''}
        </button>`;
    }

    // One browsable grid: filters always visible, matches badged and first.
    function drawerPickGridHtml(bag) {
      let shells = usableShells();
      if (state.drawer.filter !== 'all') shells = shells.filter(shell => shellCollection(shell) === state.drawer.filter);
      const matched = new Set(
        bag && bag.color
          ? usableShells().filter(shell => shellIsMatch(shell, bag)).map(shell => shell.variantId)
          : []
      );
      shells = [...shells].sort((a, b) => shellScoreForBag(b, bag) - shellScoreForBag(a, bag));
      if (!shells.length) return '<p class="bagb-drawer__empty">No shoes match that search.</p>';
      return shells.map(shell => shellPickHtml(shell, matched.has(shell.variantId))).join('');
    }

    function drawerFiltersHtml() {
      return collectionOrder.map(key => `
        <button type="button" class="bagb-filterchip${state.drawer.filter === key ? ' is-active' : ''}" data-drawer-filter-chip="${key}" aria-pressed="${state.drawer.filter === key}">
          ${escapeHtml(collectionLabels[key])}
        </button>`).join('');
    }

    // Add flow is two steps: 'shoe' picks the pair, 'laces' picks its laces.
    // Sandals and feet have no laces, so they skip straight to adding.
    function drawerNeedsLaces() {
      const shell = state.drawer.pendingShellVariantId ? shellByVariant(state.drawer.pendingShellVariantId) : null;
      return !!shell && shell.kind === 'shoe';
    }

    function updateDrawerFooter() {
      const editing = state.drawer.cardId != null;
      const onLaces = editing || state.drawer.step === 'laces';
      const pendingShell = state.drawer.pendingShellVariantId ? shellByVariant(state.drawer.pendingShellVariantId) : null;
      if (els.drawerPreview) {
        els.drawerPreview.hidden = editing;
        els.drawerPreview.innerHTML = editing
          ? ''
          : pendingShell
            ? `${pendingShell.image ? `<img src="${escapeHtml(pendingShell.image)}" alt="">` : ''}<span class="bagb-drawer__preview-text"><strong>${escapeHtml(pendingShell.title)}</strong><span>${money(pendingShell.priceCents)}</span></span>`
            : '<span class="bagb-drawer__preview-empty">Pick a pair</span>';
      }
      if (els.drawerConfirm) {
        els.drawerConfirm.disabled = !pendingShell;
        els.drawerConfirm.innerHTML = editing
          ? 'Save Laces'
          : onLaces || !drawerNeedsLaces()
            ? 'Add to Bag'
            : 'Choose laces &rarr;';
      }
      if (els.drawerBack) els.drawerBack.hidden = editing || state.drawer.step !== 'laces';
      if (els.drawerRemove) els.drawerRemove.hidden = !editing;
    }

    function renderDrawer() {
      const bag = drawerBag();
      if (!bag || !els.drawerBody) return;
      const editing = state.drawer.cardId != null;

      const pendingShell = state.drawer.pendingShellVariantId ? shellByVariant(state.drawer.pendingShellVariantId) : null;
      const pendingLace = state.drawer.pendingLaceVariantId ? laceByVariant(state.drawer.pendingLaceVariantId) : null;
      const onLaces = !editing && state.drawer.step === 'laces';
      if (els.drawerTitle) {
        els.drawerTitle.textContent = editing
          ? `Laces · ${pendingShell ? pendingShell.title : bag.name}`
          : onLaces
            ? `Laces · ${pendingShell ? pendingShell.title : bag.name}`
            : `Add Shoes · ${bag.name}`;
      }

      const laceSection = pendingShell && pendingShell.kind === 'shoe'
        ? `
          <div class="bagb-panelwell">
            <h3 class="bagb-drawer__label">Laces <span class="bagb-optional">included</span></h3>
            <div class="bagb-swatches" role="radiogroup" aria-label="Lace color">
              ${usableLaces().map(lace => {
                const isSel = pendingLace?.variantId === lace.variantId;
                const disabled = !isSel && !canSelectLace(lace, state.drawer.cardId ?? undefined);
                return `<button type="button" class="bagb-swatch${isSel ? ' is-selected' : ''}" role="radio" aria-checked="${isSel}" data-drawer-lace="${escapeHtml(lace.variantId)}" style="--sw: ${colorFor(lace.colorHandle || lace.title)}" aria-label="${escapeHtml(lace.title)}" title="${escapeHtml(lace.title)}" ${disabled ? 'disabled' : ''}>${isSel ? '<span class="bagb-swatch__check" aria-hidden="true">&#10003;</span>' : ''}</button>`;
              }).join('')}
            </div>
            <div class="bagb-lacepreview">
              ${pendingLace && pendingLace.image ? `<img class="bagb-lacepreview__img" src="${escapeHtml(resizedImage(pendingLace.image, 320))}" alt="${escapeHtml(pendingLace.title)} laces" loading="lazy">` : ''}
              <span class="bagb-lacepreview__name">${pendingLace ? `${escapeHtml(pendingLace.title)} laces` : 'Pick a lace color'}</span>
            </div>
          </div>`
        : '';

      if (editing || onLaces) {
        const out = pendingShell && (!pendingShell.available || Math.max(0, pendingShell.inventoryQuantity || 0) < 1);
        const isMatch = pendingShell && bagComplete(bag) && shellIsMatch(pendingShell, bag);
        els.drawerBody.innerHTML = `
          <section class="bagb-drawer__section">
            <div class="bagb-panelwell">
              <div class="bagb-subhead">
                <h3 class="bagb-drawer__label">Your pair</h3>
                ${isMatch ? '<span class="bagb-drawer__matchtag">Match</span>' : ''}
              </div>
              <div class="bagb-drawer__selected">
                ${pendingShell?.image ? `<img src="${escapeHtml(pendingShell.image)}" alt="">` : ''}
                <div class="bagb-drawer__selected-info">
                  <strong>${escapeHtml(pendingShell ? pendingShell.title : 'Shoes')}</strong>
                  <span>${pendingShell ? `${money(pendingShell.priceCents)} &middot; ${escapeHtml(shellKindLabel(pendingShell))}${out ? ' &middot; Out of stock' : ''}` : ''}</span>
                </div>
              </div>
            </div>
            ${laceSection}
          </section>
        `;
      } else {
        els.drawerBody.innerHTML = `
          <section class="bagb-drawer__section">
            <div class="bagb-pick-grid" role="radiogroup" aria-label="Shoes" data-drawer-all-grid>${drawerPickGridHtml(bag)}</div>
          </section>
        `;
      }
      if (els.drawerTools) {
        const showFilters = !editing && !onLaces;
        els.drawerTools.hidden = !showFilters;
        els.drawerTools.innerHTML = showFilters
          ? `<div class="bagb-pickfilters" role="group" aria-label="Filter shoes">${drawerFiltersHtml()}</div>`
          : '';
      }
      updateDrawerFooter();
    }

    function renderDrawerAllGrid() {
      const grid = els.drawerBody?.querySelector('[data-drawer-all-grid]');
      if (grid) grid.innerHTML = drawerPickGridHtml(drawerBag());
    }

    function openDrawer({ bagId, cardId = null }) {
      const bag = state.bags.find(entry => entry.id === bagId);
      if (!bag || !els.drawer) return;
      state.drawer.open = true;
      state.drawer.bagId = bagId;
      state.drawer.cardId = cardId;
      state.drawer.filter = 'all';
      state.drawer.step = 'shoe';

      if (cardId != null) {
        const card = bag.cards.find(entry => entry.id === cardId);
        state.drawer.pendingShellVariantId = card?.shellVariantId || null;
        state.drawer.pendingLaceVariantId = card?.laceVariantId || null;
      } else {
        const pendingId = recommendedShellsForBag(bag)[0]?.variantId || null;
        state.drawer.pendingShellVariantId = pendingId;
        const shell = pendingId ? shellByVariant(pendingId) : null;
        state.drawer.pendingLaceVariantId = shell && shell.kind === 'shoe'
          ? (defaultLaceForBag(bag)?.variantId || null)
          : null;
      }

      state.drawer.returnFocusEl = document.activeElement;
      renderDrawer();
      els.drawer.classList.add('is-open');
      els.drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('bagb-lock');
      els.drawerPanel?.focus();
    }

    function closeDrawer() {
      if (!state.drawer.open || !els.drawer) return;
      state.drawer.open = false;
      els.drawer.classList.remove('is-open');
      els.drawer.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('bagb-lock');
      const previous = state.drawer.returnFocusEl;
      state.drawer.returnFocusEl = null;
      if (previous && document.contains(previous)) {
        previous.focus();
      } else {
        root.querySelector(`[data-bag-card="${state.drawer.bagId}"] [data-strip-add]`)?.focus();
      }
    }

    function selectDrawerShell(variantId) {
      const bag = drawerBag();
      const shell = shellByVariant(variantId);
      if (!bag || !shell) return;
      if (state.drawer.pendingShellVariantId !== variantId && !canSelectShell(shell, state.drawer.cardId ?? undefined)) return;
      state.drawer.pendingShellVariantId = variantId;
      if (shell.kind === 'shoe') {
        const lace = state.drawer.pendingLaceVariantId ? laceByVariant(state.drawer.pendingLaceVariantId) : null;
        if (!lace || !canSelectLace(lace, state.drawer.cardId ?? undefined)) {
          state.drawer.pendingLaceVariantId = defaultLaceForBag(bag, state.drawer.cardId ?? undefined)?.variantId || null;
        }
      } else {
        state.drawer.pendingLaceVariantId = null;
      }
      renderDrawer();
    }

    function confirmDrawer() {
      const bag = drawerBag();
      if (!bag) return;
      const pendingId = state.drawer.pendingShellVariantId;
      const shell = pendingId ? shellByVariant(pendingId) : null;
      if (!shell) return;

      // Adding a lace-bearing pair: advance to the lace step first.
      if (state.drawer.cardId == null && state.drawer.step !== 'laces' && drawerNeedsLaces()) {
        if (!canSelectShell(shell)) return;
        if (!state.drawer.pendingLaceVariantId) {
          state.drawer.pendingLaceVariantId = defaultLaceForBag(bag)?.variantId || null;
        }
        state.drawer.step = 'laces';
        renderDrawer();
        els.drawerBody?.scrollTo?.({ top: 0 });
        return;
      }

      if (state.drawer.cardId != null) {
        const card = bag.cards.find(entry => entry.id === state.drawer.cardId);
        if (!card) {
          closeDrawer();
          return;
        }
        if (card.shellVariantId !== pendingId && !canSelectShell(shell, card.id)) return;
        card.shellVariantId = pendingId;
        card.laceVariantId = shell.kind === 'shoe' ? (state.drawer.pendingLaceVariantId || null) : null;
        ensureCardLace(bag, card);
      } else {
        if (!canSelectShell(shell)) return;
        addShellToBag(bag, pendingId, state.drawer.pendingLaceVariantId);
      }
      render();
      closeDrawer();
    }

    function removeFromDrawer() {
      const bag = drawerBag();
      if (!bag || state.drawer.cardId == null) return;
      const removedId = state.drawer.cardId;
      bag.cards = bag.cards.filter(card => card.id !== removedId);
      if (bag.previewCardId === removedId) bag.previewCardId = bag.cards[bag.cards.length - 1]?.id ?? null;
      render();
      closeDrawer();
    }

    /* ---------- cart ---------- */

    async function addToCart() {
      if (!validToCart()) return;
      const items = [];

      state.bags.forEach((bag, bagIndex) => {
        const firstShell = cardShell(bag.cards[0]);
        const kitId = createKitId(`bag-${bag.id}`);
        // No user-entered bag name anymore — derive a readable title from the primary color.
        const bundleName = bagColor(bag.color)?.label || 'Custom';
        const shared = {
          _component_kit: 'true',
          _kit_id: kitId,
          _kit_title: `${bundleName} Bag · Full Set`,
          _kit_image: firstShell?.image || '',
          _kit_kind: 'bag-builder',
          _kit_bag_name: bundleName,
          _kit_bag_color: bagColor(bag.color)?.label || '',
          _kit_bag_color_accent: bag.accentColor ? (bagColor(bag.accentColor)?.label || '') : '',
          _kit_bag_stand_size: standSize(bag.stand)?.title || ''
        };

        bag.cards.forEach((card, cardIndex) => {
          const shell = cardShell(card);
          if (!shell) return;
          const shellProps = {
            ...shared,
            _kit_role: 'shell',
            _kit_role_title: shell.title,
            _kit_image: shell.image || shared._kit_image
          };
          if (cardIndex > 0) shellProps._kit_extra_shell = 'true';
          items.push({ id: shell.variantId, quantity: 1, properties: shellProps });

          const lace = cardLace(card);
          if (shell.kind === 'shoe' && lace) {
            items.push({
              id: lace.variantId,
              quantity: 1,
              properties: {
                ...shared,
                _kit_role: 'laces',
                _kit_role_title: `${lace.title} Laces`,
                _kit_shell_title: shell.title
              }
            });
          }
        });

        const insert = insertByVariant(bag.insertVariantId);
        if (insert) {
          items.push({
            id: insert.variantId,
            quantity: 1,
            properties: {
              ...shared,
              _kit_role: 'insert',
              _kit_role_title: `${insert.title} Insert`,
              _kit_insert_for_bag: String(bagIndex + 1)
            }
          });
        }
      });

      const primary = items.shift();
      if (!primary) return;
      await window.ShoogieGolf.cart.addItem(primary.id, primary.quantity, els.addCart, {
        extraItems: items,
        properties: primary.properties
      });
      // Success → the "Added — build another?" state (cart drawer opens too).
      state.screen = 'added';
      render();
    }

    // Reset to a fresh empty bag and return to the build editor ("Build another bag").
    function resetToNewBag() {
      state.bags = [];
      const bag = createBag();
      state.activeBagId = bag.id;
      state.screen = 'build';
      state.stagePop = { bagId: null, kind: null };
      syncPopLock();
      render();
      root.scrollIntoView({ behavior: prefersReducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
    }

    /* ---------- events ---------- */

    function openSizeGuide() {
      if (!els.guide || !window.shoobieOpenModal) return;
      window.shoobieOpenModal(els.guide.id);
    }

    function bagFromEvent(target) {
      const cardEl = target.closest('[data-bag-card]');
      if (!cardEl) return null;
      return state.bags.find(bag => String(bag.id) === cardEl.dataset.bagCard) || null;
    }

    root.addEventListener('click', event => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;
      let el;

      // Drawer controls
      if (target.closest('[data-drawer-close]')) {
        closeDrawer();
        return;
      }
      if ((el = target.closest('[data-drawer-shell]'))) {
        selectDrawerShell(el.dataset.drawerShell);
        return;
      }
      if ((el = target.closest('[data-drawer-lace]'))) {
        if (el.disabled) return;
        state.drawer.pendingLaceVariantId = el.dataset.drawerLace;
        renderDrawer();
        return;
      }
      if ((el = target.closest('[data-drawer-filter-chip]'))) {
        state.drawer.filter = el.dataset.drawerFilterChip || 'all';
        renderDrawer();
        return;
      }
      if (target.closest('[data-drawer-confirm]')) {
        confirmDrawer();
        return;
      }
      if (target.closest('[data-drawer-back]')) {
        state.drawer.step = 'shoe';
        renderDrawer();
        return;
      }
      if (target.closest('[data-drawer-remove]')) {
        removeFromDrawer();
        return;
      }

      // Page controls
      if (target.closest('[data-size-guide-open]')) {
        openSizeGuide();
        return;
      }
      if (target.closest('[data-how-open]')) {
        openHowGuide();
        return;
      }
      if (target.closest('[data-bag-add-cart]')) {
        addToCart();
        return;
      }

      // Screen navigation (single-bag flow): build ⇄ review, then "build another"
      if (target.closest('[data-review-open]')) {
        if (!validToCart()) return;
        state.screen = 'review';
        state.stagePop = { bagId: null, kind: null };
        render();
        syncPopLock(); // lock scroll while the review sheet is up (mobile)
        return;
      }
      if (target.closest('[data-review-edit]')) {
        state.screen = 'build';
        render();
        syncPopLock(); // release the scroll lock when the sheet closes
        return;
      }
      if (target.closest('[data-build-another]')) {
        resetToNewBag();
        return;
      }

      // Dock: the two build steps act on the active bag (single-bag editor)
      if ((el = target.closest('[data-dock]'))) {
        const bag = activeBag();
        if (!bag) return;
        const kind = el.dataset.dock;
        if (kind === 'shoes') {
          openDrawer({ bagId: bag.id });
        } else {
          const isOpen = state.stagePop.bagId === bag.id && state.stagePop.kind === kind;
          state.stagePop = isOpen ? { bagId: null, kind: null } : { bagId: bag.id, kind };
          syncPopLock();
          render();
        }
        return;
      }
      // How button lives on the stage now, not the dock
      if (target.closest('[data-how-sheet-open]')) {
        if (!activeBag()) return;
        state.howOpen = true;
        syncPopLock();
        render();
        return;
      }
      if (target.closest('[data-how-close]')) {
        state.howOpen = false;
        syncPopLock();
        render();
        return;
      }

      // Card-scoped controls
      const cardBag = bagFromEvent(target);
      if (cardBag) {
        if ((el = target.closest('[data-name-edit]'))) {
          const input = el.closest('.bagb-card__name-wrap')?.querySelector('[data-bag-name]');
          if (input) {
            input.focus();
            input.select();
          }
          return;
        }
        if (target.closest('[data-pop-close]')) {
          state.stagePop = { bagId: null, kind: null };
          syncPopLock();
          render();
          return;
        }
        if ((el = target.closest('[data-pop-toggle]'))) {
          const kind = el.dataset.popToggle;
          const isOpen = state.stagePop.bagId === cardBag.id && state.stagePop.kind === kind;
          state.stagePop = isOpen ? { bagId: null, kind: null } : { bagId: cardBag.id, kind };
          syncPopLock();
          render();
          return;
        }
        if ((el = target.closest('[data-bag-color]'))) {
          cardBag.color = el.dataset.bagColor === 'none' ? null : el.dataset.bagColor;
          render();
          return;
        }
        if ((el = target.closest('[data-bag-accent]'))) {
          cardBag.accentColor = el.dataset.bagAccent === 'none' ? null : el.dataset.bagAccent;
          render();
          return;
        }
        if ((el = target.closest('[data-bag-stand]'))) {
          const wasComplete = bagComplete(cardBag);
          cardBag.stand = el.dataset.bagStand;
          const insert = recommendedInsertForStand(cardBag.stand, cardBag.id);
          cardBag.insertVariantId = insert ? insert.variantId : null;
          if (!wasComplete && bagComplete(cardBag)) {
            // Setup just finished — honor a PDP deep link by dropping that pair in.
            if (state.pendingPreselectShellId) {
              const requested = shellByVariant(state.pendingPreselectShellId);
              if (requested && canSelectShell(requested)) addShellToBag(cardBag, requested.variantId);
              state.pendingPreselectShellId = null;
            }
          }
          render();
          return;
        }
        if ((el = target.closest('[data-preview-card]'))) {
          cardBag.previewCardId = Number(el.dataset.previewCard);
          render();
          return;
        }
        if (target.closest('[data-strip-add]')) {
          openDrawer({ bagId: cardBag.id });
          return;
        }
        if ((el = target.closest('[data-card-edit]'))) {
          openDrawer({ bagId: cardBag.id, cardId: Number(el.dataset.cardEdit) });
          return;
        }
      }
    });

    root.addEventListener('input', event => {
      const target = event.target;
      if (!(target instanceof Element)) return;

      if (target.matches('[data-bag-name]')) {
        const bag = bagFromEvent(target);
        if (!bag) return;
        bag.name = target.value || `Bag ${bag.id}`;
        renderSummary();
        return;
      }

    });


    // Document-scoped (not root-scoped): every stagePop-changing click re-renders
    // the card via innerHTML, which drops focus back to <body> — a root-scoped
    // keydown listener would never see the bubbled Escape after that happens.
    if (bagbPopCloseHandlers) {
      document.removeEventListener('click', bagbPopCloseHandlers.click);
      document.removeEventListener('keydown', bagbPopCloseHandlers.keydown);
    }
    bagbPopCloseHandlers = {
      click: event => {
        if (!state.stagePop.kind) return;
        const target = event.target instanceof Element ? event.target : null;
        if (target && (target.closest('[data-stage-pop]') || target.closest('[data-pop-toggle]') || target.closest('[data-dock]'))) return;
        const nameTarget = target?.closest('[data-bag-name]') ? target.closest('[data-bag-card]')?.dataset.bagCard : null;
        state.stagePop = { bagId: null, kind: null };
        syncPopLock();
        render();
        if (nameTarget) {
          root.querySelector(`[data-bag-card="${nameTarget}"] [data-bag-name]`)?.focus();
        }
      },
      keydown: event => {
        if (event.key === 'Escape' && state.stagePop.kind) {
          state.stagePop = { bagId: null, kind: null };
          syncPopLock();
          render();
        }
      }
    };
    document.addEventListener('click', bagbPopCloseHandlers.click);
    document.addEventListener('keydown', bagbPopCloseHandlers.keydown);

    els.drawer?.addEventListener('keydown', event => {
      if (!state.drawer.open) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        closeDrawer();
        return;
      }
      if (event.key !== 'Tab' || !els.drawerPanel) return;
      const focusables = [...els.drawerPanel.querySelectorAll('button:not([disabled]), input, select, [href], [tabindex]:not([tabindex="-1"])')]
        .filter(node => node.offsetParent !== null);
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (event.shiftKey && (document.activeElement === first || document.activeElement === els.drawerPanel)) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    function initHowVideo() {
      root.querySelectorAll('[data-how-video]').forEach(wrap => initHowVideoWrap(wrap));
    }

    function initHowVideoWrap(wrap) {
      const video = wrap.querySelector('video');
      if (!video) return;
      const toggleBtn = wrap.querySelector('[data-video-toggle]');
      const muteBtn = wrap.querySelector('[data-video-mute]');
      const speed = Math.max(0.25, parseFloat(wrap.dataset.videoSpeed || '1') || 1);
      const boomerang = wrap.dataset.videoMode === 'boomerang';
      video.defaultPlaybackRate = speed;
      video.playbackRate = speed;

      // Browsers can't play video backward natively, so boomerang mode
      // scrubs currentTime back to 0 on animation frames after 'ended'.
      let reverseRaf = null;
      let reverseLastTs = null;
      const reversing = () => reverseRaf != null;
      const stopReverse = () => {
        if (reverseRaf != null) cancelAnimationFrame(reverseRaf);
        reverseRaf = null;
        reverseLastTs = null;
      };
      const stepReverse = ts => {
        if (reverseLastTs == null) reverseLastTs = ts;
        const dt = (ts - reverseLastTs) / 1000;
        reverseLastTs = ts;
        const next = video.currentTime - dt * speed;
        if (next <= 0.05) {
          stopReverse();
          video.currentTime = 0;
          video.play();
          sync();
          return;
        }
        video.currentTime = next;
        reverseRaf = requestAnimationFrame(stepReverse);
      };

      const sync = () => {
        wrap.classList.toggle('is-paused', video.paused && !reversing());
        wrap.classList.toggle('is-muted', video.muted);
        toggleBtn?.setAttribute('aria-label', video.paused && !reversing() ? 'Play video' : 'Pause video');
        muteBtn?.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      };
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      video.addEventListener('volumechange', sync);
      if (boomerang) {
        video.addEventListener('ended', () => {
          reverseLastTs = null;
          reverseRaf = requestAnimationFrame(stepReverse);
          sync();
        });
      }
      wrap.addEventListener('click', event => {
        const target = event.target instanceof Element ? event.target : null;
        if (!target) return;
        if (target.closest('[data-video-mute]')) {
          video.muted = !video.muted;
          return;
        }
        if (target.closest('[data-video-toggle]') || target.closest('video')) {
          if (reversing()) {
            stopReverse();
            sync();
          } else if (video.paused) {
            video.play();
          } else {
            video.pause();
          }
        }
      });
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) video.pause();
      // The sidebar copy is display:none below 1024px (the modal takes over);
      // don't let it keep playing invisibly.
      if (wrap.closest('[data-aside-how]') && window.matchMedia('(max-width: 1023px)').matches) video.pause();
      sync();
    }

    function initHowGuide() {
      if (!els.howGuide) return;
      const video = els.howGuide.querySelector('[data-how-video] video');
      if (!video) return;
      new MutationObserver(() => {
        if (els.howGuide.classList.contains('is-open')) video.play();
        else video.pause();
      }).observe(els.howGuide, { attributes: true, attributeFilter: ['class'] });
    }

    function openHowGuide() {
      if (!els.howGuide || !window.shoobieOpenModal) return;
      window.shoobieOpenModal(els.howGuide.id);
    }

    initHowVideo();
    initHowGuide();
    state.pendingPreselectShellId = initialShell()?.variantId || null;
    const firstBag = createBag();
    state.activeBagId = firstBag.id;
    state.screen = 'build';
    render();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-bag-bundle-builder]').forEach(root => {
      if (root.dataset.bagbReady) return;
      root.dataset.bagbReady = 'true';
      initBagBuilder(root);
    });
  }

  document.addEventListener('DOMContentLoaded', () => initAll());

  // The theme editor re-renders the section HTML on every setting change,
  // wiping the JS-built bag cards and their listeners — re-init on the fresh
  // nodes (and clear a scroll lock the old drawer may have left behind).
  document.addEventListener('shopify:section:load', event => {
    document.body.classList.remove('bagb-lock');
    initAll(event.target instanceof Element ? event.target : document);
  });
})();
